// import React, { useRef, useState, useEffect, useCallback } from 'react';
// import axios from 'axios';
// import { useAuth } from '../context/AuthContext';
// import {
//     Box, Typography, Grid, Card, CardMedia, CardContent, Chip, MenuItem, Select,
//     FormControl, Dialog, DialogContent, Button, IconButton, Snackbar, Alert, Fade,
//     Zoom, Skeleton, Tooltip, useTheme, useMediaQuery, CircularProgress
// } from '@mui/material';
// import {
//     CheckCircle, Close, ZoomIn, ZoomOut, OpenInFull, FilePresent, KeyboardArrowDown,
//     AutoAwesome, BarChart
// } from '@mui/icons-material';

// // ─── DESIGN TOKENS ────────────────────────────────────────────────────────────
// const FB = "#1877F2";
// const FB_DARK = "#0C5FD6";
// const FB_LIGHT = "#E7F0FD";
// const FB_MID = "#B3CFF9";
// const BG = "#F0F4FF";
// const BORDER = "#DCE3F5";
// const T1 = "#0F1B35";
// const T2 = "#5A6A8A";
// const GREEN = "#1a9e5c";
// const GREEN_LT = "#e6f7ef";
// const RED = "#E24B4A";

// // ─── CONSTANTS ────────────────────────────────────────────────────────────────
// const publicUrl = typeof process !== 'undefined' && process.env?.PUBLIC_URL ? process.env.PUBLIC_URL : '';
// const dummyImg = `${publicUrl}/Quotation_Image.jpeg`;

// const getImageForTypeFormat = (type = '', format = 0) => {
//     const idx = Number(format) || 0;
//     if (!idx || idx < 1 || idx > 10) return { thumb: dummyImg, large: dummyImg };
//     const norm = (type || '').replace(/\s+/g, '').toLowerCase();
//     const build = (base) => `${publicUrl}/${base}${idx}.jpg`;
//     const map = {
//         quotation: () => build('Quotation'),
//         saleorder: () => build('SaleOrder'),
//         proformainvoice: () => build('ProformaInvoice'),
//         salechallan: () => build('SaleChallan'),
//         saleinvoice: () => build('SaleInvoice'),
//         creditnote: () => build('CreditNote'),
//         purchaseorder: () => build('PurchaseOrder'),
//         purchasedispatch: () => build('PurchaseChallan'),
//         purchaseinvoice: () => build('PurchaseInvoice'),
//         debitnote: () => build('DebitNote'),
//     };
//     const src = map[norm] ? map[norm]() : dummyImg;
//     return { thumb: src, large: src };
// };

// const documentTypes = [
//     'Quotation',
//     'Proforma Invoice',
//     'Sale Challan',
//     'Sale Invoice',
// ];

// // Document types that support multiple series
// const MULTI_SERIES_TYPES = ['Sale Challan', 'Sale Invoice', 'Proforma Invoice', 'Credit Note'];

// const FORMAT_COUNT = 10;
// const formats = Array.from({ length: FORMAT_COUNT }, (_, i) => i + 1);

// // ─── SHARED SX ────────────────────────────────────────────────────────────────
// const cardBaseSx = {
//     background: "#fff", border: `0.5px solid ${BORDER}`, borderRadius: "12px",
// };

// const btnPrimarySx = {
//     background: FB, color: "#fff", borderRadius: "8px", fontSize: 13, fontWeight: 500,
//     textTransform: "none", px: 2.5, height: 38,
//     "&:hover": { background: FB_DARK },
//     "&:disabled": { background: FB_MID, color: "#fff" },
// };

// const btnGhostSx = {
//     background: "transparent", color: T2, border: `0.5px solid ${BORDER}`, borderRadius: "8px",
//     fontSize: 13, fontWeight: 500, textTransform: "none", px: 2.5, height: 38,
//     "&:hover": { background: "#fff", color: T1 },
// };

// // ─── SERIES CARD ──────────────────────────────────────────────────────────────
// function SeriesCard({ series, isSelected, appliedFormat, onClick, index }) {
//     const seriesName = series?.SeriesName || series?.seriesName || series?.Name || series?.name || `Series ${series?.SeriesId || series?.SeriesID || index + 1}`;
//     const seriesId = series?.SeriesId || series?.SeriesID || series?.seriesId || series?.Id || series?.id || index + 1;

//     return (
//         <Zoom in style={{ transitionDelay: `${index * 40}ms` }}>
//             <Card
//                 onClick={() => onClick(series)}
//                 sx={{
//                     cursor: "pointer", borderRadius: "12px", overflow: "hidden",
//                     border: isSelected ? `2px solid ${FB}` : `0.5px solid ${BORDER}`,
//                     outline: isSelected ? `4px solid ${FB_LIGHT}` : "none",
//                     boxShadow: "none", transition: "all 0.2s ease",
//                     "&:hover": {
//                         boxShadow: `0 6px 24px rgba(24,119,242,0.14)`,
//                         transform: "translateY(-4px)", borderColor: FB,
//                     },
//                     background: "#fff", p: 2,
//                 }}
//             >
//                 <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//                         <Box sx={{
//                             width: 40, height: 40, borderRadius: "10px",
//                             bgcolor: isSelected ? FB : FB_LIGHT,
//                             display: "flex", alignItems: "center", justifyContent: "center",
//                             transition: "all 0.2s ease",
//                         }}>
//                             <BarChart sx={{ fontSize: 20, color: isSelected ? "#fff" : FB }} />
//                         </Box>
//                         <Box>
//                             <Typography sx={{ fontSize: 14, fontWeight: 500, color: T1, lineHeight: 1.3 }}>
//                                 {seriesName}
//                             </Typography>
//                             <Typography sx={{ fontSize: 11, color: T2 }}>
//                                 Series ID: {seriesId}
//                             </Typography>
//                         </Box>
//                     </Box>
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                         {appliedFormat && (
//                             <Chip
//                                 icon={<CheckCircle sx={{ fontSize: 13, color: `${GREEN} !important` }} />}
//                                 label={`Format ${appliedFormat}`}
//                                 size="small"
//                                 sx={{
//                                     fontSize: 11, fontWeight: 500, height: 24,
//                                     bgcolor: GREEN_LT, color: GREEN,
//                                     border: `0.5px solid ${GREEN}44`,
//                                     "& .MuiChip-icon": { ml: "6px" },
//                                 }}
//                             />
//                         )}
//                         {isSelected && (
//                             <Box sx={{
//                                 width: 24, height: 24, borderRadius: "50%", bgcolor: FB,
//                                 display: "flex", alignItems: "center", justifyContent: "center",
//                             }}>
//                                 <CheckCircle sx={{ color: "#fff", fontSize: 16 }} />
//                             </Box>
//                         )}
//                     </Box>
//                 </Box>
//             </Card>
//         </Zoom>
//     );
// }

// // ─── FORMAT CARD ──────────────────────────────────────────────────────────────
// function FormatCard({ format, selectedType, isApplied, onClick }) {
//     const [imgLoaded, setImgLoaded] = useState(false);
//     const { thumb } = getImageForTypeFormat(selectedType, format);

//     return (
//         <Zoom in style={{ transitionDelay: `${(format - 1) * 40}ms` }}>
//             <Card
//                 onClick={onClick}
//                 sx={{
//                     cursor: "pointer", borderRadius: "12px", overflow: "hidden",
//                     border: isApplied ? `2px solid ${FB}` : `0.5px solid ${BORDER}`,
//                     outline: isApplied ? `4px solid ${FB_LIGHT}` : "none",
//                     boxShadow: "none", transition: "all 0.2s ease",
//                     "&:hover": {
//                         boxShadow: `0 6px 24px rgba(24,119,242,0.14)`,
//                         transform: "translateY(-4px)", borderColor: FB,
//                     },
//                     position: "relative", background: "#fff",
//                 }}
//             >
//                 <Box sx={{ position: "relative", bgcolor: BG, height: { xs: 160, sm: 200, md: 220 }, overflow: "hidden" }}>
//                     {!imgLoaded && (
//                         <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" sx={{ bgcolor: FB_LIGHT }} />
//                     )}
//                     <CardMedia component="img" image={thumb} alt={`Format ${format}`}
//                         onLoad={() => setImgLoaded(true)}
//                         onError={(e) => { e.currentTarget.src = dummyImg; setImgLoaded(true); }}
//                         sx={{
//                             height: "100%", objectFit: "cover",
//                             display: imgLoaded ? "block" : "none",
//                             transition: "transform 0.3s ease",
//                             "&:hover": { transform: "scale(1.04)" },
//                         }}
//                     />
//                     <Box sx={{
//                         position: "absolute", inset: 0,
//                         background: "linear-gradient(to top, rgba(24,119,242,0.25) 0%, transparent 50%)",
//                         pointerEvents: "none",
//                     }} />
//                     <Box sx={{
//                         position: "absolute", top: 10, left: 10, px: "8px", py: "3px",
//                         background: isApplied ? FB : "rgba(255,255,255,0.9)",
//                         borderRadius: "6px", border: `0.5px solid ${isApplied ? FB : BORDER}`,
//                     }}>
//                         <Typography sx={{ fontSize: 11, fontWeight: 500, color: isApplied ? "#fff" : T2 }}>
//                             Format {format}
//                         </Typography>
//                     </Box>
//                     {isApplied && (
//                         <Box sx={{
//                             position: "absolute", top: 10, right: 10,
//                             width: 28, height: 28, borderRadius: "50%",
//                             bgcolor: GREEN, display: "flex",
//                             alignItems: "center", justifyContent: "center",
//                         }}>
//                             <CheckCircle sx={{ color: "#fff", fontSize: 18 }} />
//                         </Box>
//                     )}
//                 </Box>
//                 <CardContent sx={{ py: 1.25, px: 1.5, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//                     <Typography sx={{ fontSize: 13, fontWeight: 500, color: T1 }}>
//                         Format {format}
//                     </Typography>
//                     {isApplied ? (
//                         <Chip
//                             icon={<CheckCircle sx={{ fontSize: 14, color: `${GREEN} !important` }} />}
//                             label="Active"
//                             size="small"
//                             sx={{
//                                 fontSize: 11, fontWeight: 500, height: 22,
//                                 bgcolor: GREEN_LT, color: GREEN,
//                                 border: `0.5px solid ${GREEN}44`,
//                                 "& .MuiChip-icon": { ml: "6px" },
//                             }}
//                         />
//                     ) : (
//                         <Chip
//                             label="Preview"
//                             size="small"
//                             sx={{
//                                 fontSize: 11, height: 22,
//                                 bgcolor: FB_LIGHT, color: FB,
//                                 border: `0.5px solid ${FB_MID}`,
//                             }}
//                         />
//                     )}
//                 </CardContent>
//             </Card>
//         </Zoom>
//     );
// }

// // ─── PREVIEW DIALOG ───────────────────────────────────────────────────────────
// function PreviewDialog({ open, onClose, selectedType, selectedFormat, onApply, appliedFormat, selectedSeries }) {

//     // ── All values stored in refs so event listeners always see latest values ──
//     const scaleRef = useRef(1);
//     const originRef = useRef({ x: 50, y: 50 });
//     const translateRef = useRef({ x: 0, y: 0 });
//     const isDraggingRef = useRef(false);
//     const dragStartRef = useRef({ mouseX: 0, mouseY: 0, translateX: 0, translateY: 0 });

//     // ── React state only for triggering re-renders ──
//     const [scale, setScale] = useState(1);
//     const [origin, setOrigin] = useState({ x: 50, y: 50 });
//     const [translate, setTranslate] = useState({ x: 0, y: 0 });
//     const [isDragging, setIsDragging] = useState(false);

//     const containerRef = useRef(null);

//     const { large } = getImageForTypeFormat(selectedType, selectedFormat);
//     const isAlreadyApplied = appliedFormat === selectedFormat;
//     const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'));
//     const isMultiSeries = MULTI_SERIES_TYPES.includes(selectedType);
//     const seriesName = selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || selectedSeries?.name || '';

//     // ── Master reset ──────────────────────────────────────────────────────────
//     const resetAll = useCallback(() => {
//         scaleRef.current = 1;
//         originRef.current = { x: 50, y: 50 };
//         translateRef.current = { x: 0, y: 0 };
//         isDraggingRef.current = false;
//         setScale(1);
//         setOrigin({ x: 50, y: 50 });
//         setTranslate({ x: 0, y: 0 });
//         setIsDragging(false);
//     }, []);

//     // ── Reset when dialog closes ──────────────────────────────────────────────
//     useEffect(() => {
//         if (!open) resetAll();
//     }, [open, resetAll]);

//     // ── Get pointer position as % inside the container ────────────────────────
//     const getPointerOrigin = useCallback((clientX, clientY) => {
//         const container = containerRef.current;
//         if (!container) return { x: 50, y: 50 };
//         const rect = container.getBoundingClientRect();
//         const x = Math.min(Math.max(((clientX - rect.left) / rect.width) * 100, 0), 100);
//         const y = Math.min(Math.max(((clientY - rect.top) / rect.height) * 100, 0), 100);
//         return { x, y };
//     }, []);

//     // ── Core zoom function — reads/writes refs, then syncs state ──────────────
//     const applyZoom = useCallback((delta, pointerOrigin) => {
//         const newScale = Math.min(Math.max(scaleRef.current * delta, 0.4), 5);
//         scaleRef.current = newScale;

//         if (pointerOrigin) {
//             originRef.current = pointerOrigin;
//             setOrigin({ ...pointerOrigin });
//         }

//         // Auto-reset translation when fully zoomed out
//         if (newScale <= 1) {
//             translateRef.current = { x: 0, y: 0 };
//             setTranslate({ x: 0, y: 0 });
//         }

//         setScale(newScale);
//     }, []);

//     // ── Wheel handler — defined with useCallback so it is stable ─────────────
//     const handleWheel = useCallback((e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         const po = getPointerOrigin(e.clientX, e.clientY);
//         const delta = e.deltaY > 0 ? 0.93 : 1.07;
//         applyZoom(delta, po);
//     }, [getPointerOrigin, applyZoom]);

//     // ── Attach wheel listener with { passive: false } on the container ────────
//     // Re-attach whenever handleWheel changes (it's stable, so this runs once per open)
//     useEffect(() => {
//         const el = containerRef.current;
//         if (!el || !open) return;
//         el.addEventListener('wheel', handleWheel, { passive: false });
//         return () => {
//             el.removeEventListener('wheel', handleWheel);
//         };
//     }, [open, handleWheel]);

//     // ── Button zoom — uses last known pointer origin ──────────────────────────
//     const handleZoomIn = useCallback(() => {
//         applyZoom(1.25, originRef.current);
//     }, [applyZoom]);

//     const handleZoomOut = useCallback(() => {
//         applyZoom(0.8, originRef.current);
//     }, [applyZoom]);

//     const handleReset = useCallback(() => {
//         resetAll();
//     }, [resetAll]);

//     // ── Mouse move — track pointer for button-zoom aim + handle drag ──────────
//     const handleMouseMove = useCallback((e) => {
//         if (!isDraggingRef.current) {
//             // Keep origin ref updated so button zooms aim at cursor
//             originRef.current = getPointerOrigin(e.clientX, e.clientY);
//             return;
//         }
//         // While dragging compute new translation
//         const dx = e.clientX - dragStartRef.current.mouseX;
//         const dy = e.clientY - dragStartRef.current.mouseY;
//         const newTranslate = {
//             x: dragStartRef.current.translateX + dx,
//             y: dragStartRef.current.translateY + dy,
//         };
//         translateRef.current = newTranslate;
//         setTranslate({ ...newTranslate });
//     }, [getPointerOrigin]);

//     // ── Mouse down — begin drag only when zoomed in ───────────────────────────
//     const handleMouseDown = useCallback((e) => {
//         if (scaleRef.current <= 1) return;
//         e.preventDefault();
//         isDraggingRef.current = true;
//         setIsDragging(true);
//         dragStartRef.current = {
//             mouseX: e.clientX,
//             mouseY: e.clientY,
//             translateX: translateRef.current.x,
//             translateY: translateRef.current.y,
//         };
//     }, []);

//     // ── Mouse up — stop drag the instant button is released ──────────────────
//     const handleMouseUp = useCallback(() => {
//         if (!isDraggingRef.current) return;
//         isDraggingRef.current = false;
//         setIsDragging(false);
//     }, []);

//     // ── Mouse leave — stop drag so image never gets stuck ────────────────────
//     const handleMouseLeave = useCallback(() => {
//         if (!isDraggingRef.current) return;
//         isDraggingRef.current = false;
//         setIsDragging(false);
//     }, []);

//     // ── Touch handlers (mobile) ───────────────────────────────────────────────
//     const handleTouchStart = useCallback((e) => {
//         if (scaleRef.current <= 1 || e.touches.length !== 1) return;
//         const touch = e.touches[0];
//         isDraggingRef.current = true;
//         setIsDragging(true);
//         dragStartRef.current = {
//             mouseX: touch.clientX,
//             mouseY: touch.clientY,
//             translateX: translateRef.current.x,
//             translateY: translateRef.current.y,
//         };
//     }, []);

//     const handleTouchMove = useCallback((e) => {
//         if (!isDraggingRef.current || e.touches.length !== 1) return;
//         e.preventDefault();
//         const touch = e.touches[0];
//         const dx = touch.clientX - dragStartRef.current.mouseX;
//         const dy = touch.clientY - dragStartRef.current.mouseY;
//         const newTranslate = {
//             x: dragStartRef.current.translateX + dx,
//             y: dragStartRef.current.translateY + dy,
//         };
//         translateRef.current = newTranslate;
//         setTranslate({ ...newTranslate });
//     }, []);

//     const handleTouchEnd = useCallback(() => {
//         isDraggingRef.current = false;
//         setIsDragging(false);
//     }, []);

//     // ── Attach touchmove with { passive: false } so preventDefault works ──────
//     useEffect(() => {
//         const el = containerRef.current;
//         if (!el || !open) return;
//         el.addEventListener('touchmove', handleTouchMove, { passive: false });
//         return () => {
//             el.removeEventListener('touchmove', handleTouchMove);
//         };
//     }, [open, handleTouchMove]);

//     // ─────────────────────────────────────────────────────────────────────────
//     return (
//         <Dialog
//             open={open}
//             onClose={onClose}
//             maxWidth="md"
//             fullWidth
//             fullScreen={isMobile}
//             TransitionComponent={Fade}
//             PaperProps={{
//                 sx: {
//                     borderRadius: isMobile ? 0 : "14px",
//                     overflow: "hidden",
//                     maxHeight: isMobile ? "100vh" : "92vh",
//                     border: `0.5px solid ${BORDER}`,
//                 }
//             }}
//         >
//             {/* ── Header ── */}
//             <Box sx={{
//                 display: "flex", alignItems: "center", justifyContent: "space-between",
//                 px: { xs: 2, sm: 3 }, py: 1.75,
//                 background: FB, color: "#fff",
//                 borderBottom: `1.5px solid ${FB_DARK}`,
//             }}>
//                 <Box>
//                     <Typography sx={{ fontSize: 15, fontWeight: 500, color: "#fff" }}>
//                         {selectedType}
//                         {isMultiSeries && seriesName && (
//                             <Box component="span" sx={{ ml: 1, fontSize: 12, color: "rgba(255,255,255,0.75)" }}>
//                                 — {seriesName}
//                             </Box>
//                         )}
//                     </Typography>
//                     <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.7)" }}>
//                         Format {selectedFormat}
//                     </Typography>
//                 </Box>
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//                     <Tooltip title="Zoom out">
//                         <IconButton size="small" sx={{ color: "#fff" }} onClick={handleZoomOut}>
//                             <ZoomOut sx={{ fontSize: 18 }} />
//                         </IconButton>
//                     </Tooltip>
//                     <Box sx={{
//                         px: "8px", py: "3px", bgcolor: "rgba(255,255,255,0.15)",
//                         borderRadius: "6px", mx: 0.5,
//                     }}>
//                         <Typography sx={{ fontSize: 12, fontWeight: 500, color: "#fff", minWidth: 40, textAlign: "center" }}>
//                             {Math.round(scale * 100)}%
//                         </Typography>
//                     </Box>
//                     <Tooltip title="Zoom in">
//                         <IconButton size="small" sx={{ color: "#fff" }} onClick={handleZoomIn}>
//                             <ZoomIn sx={{ fontSize: 18 }} />
//                         </IconButton>
//                     </Tooltip>
//                     <Tooltip title="Reset">
//                         <IconButton size="small" sx={{ color: "#fff" }} onClick={handleReset}>
//                             <OpenInFull sx={{ fontSize: 16 }} />
//                         </IconButton>
//                     </Tooltip>
//                     <IconButton size="small" sx={{ color: "#fff", ml: 0.5 }} onClick={onClose}>
//                         <Close sx={{ fontSize: 18 }} />
//                     </IconButton>
//                 </Box>
//             </Box>

//             {/* ── Image / drag area ── */}
//             <DialogContent
//                 ref={containerRef}
//                 sx={{
//                     p: 0,
//                     bgcolor: BG,
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     minHeight: isMobile ? "calc(100vh - 140px)" : 400,
//                     overflow: "hidden",
//                     cursor: isDragging ? "grabbing" : scale > 1 ? "grab" : "zoom-in",
//                     position: "relative",
//                     userSelect: "none",
//                 }}
//                 onMouseMove={handleMouseMove}
//                 onMouseDown={handleMouseDown}
//                 onMouseUp={handleMouseUp}
//                 onMouseLeave={handleMouseLeave}
//                 onTouchStart={handleTouchStart}
//                 onTouchEnd={handleTouchEnd}
//             >
//                 <Box
//                     sx={{
//                         // No transition while dragging for instant response
//                         transition: isDragging ? "none" : "transform 0.12s ease",
//                         transform: `translate(${translate.x}px, ${translate.y}px) scale(${scale})`,
//                         transformOrigin: `${origin.x}% ${origin.y}%`,
//                         display: "inline-block",
//                         lineHeight: 0,
//                         // Prevent the inner box from catching pointer events
//                         pointerEvents: "none",
//                     }}
//                 >
//                     <img
//                         src={large}
//                         alt="Preview"
//                         draggable={false}
//                         onError={(e) => { e.currentTarget.src = dummyImg; }}
//                         style={{
//                             maxWidth: "100%",
//                             maxHeight: isMobile ? "70vh" : "60vh",
//                             objectFit: "contain",
//                             display: "block",
//                             userSelect: "none",
//                             pointerEvents: "none",
//                         }}
//                     />
//                 </Box>
//             </DialogContent>

//             {/* ── Footer ── */}
//             <Box sx={{
//                 px: { xs: 2, sm: 3 }, py: 2,
//                 display: "flex", gap: 1.5, justifyContent: "flex-end",
//                 borderTop: `0.5px solid ${BORDER}`, bgcolor: "#fff",
//                 flexWrap: "wrap",
//             }}>
//                 <Button onClick={onClose} sx={btnGhostSx}>Cancel</Button>
//                 <Button
//                     onClick={onApply}
//                     disabled={isAlreadyApplied}
//                     startIcon={isAlreadyApplied
//                         ? <CheckCircle sx={{ fontSize: 16 }} />
//                         : <AutoAwesome sx={{ fontSize: 16 }} />}
//                     sx={{
//                         ...btnPrimarySx,
//                         ...(isAlreadyApplied && {
//                             bgcolor: GREEN_LT, color: GREEN,
//                             border: `0.5px solid ${GREEN}44`,
//                             "&:disabled": { bgcolor: GREEN_LT, color: GREEN }
//                         }),
//                     }}
//                 >
//                     {isAlreadyApplied ? "Currently active" : "Apply template"}
//                 </Button>
//             </Box>
//         </Dialog>
//     );
// }

// // ─── MAIN ─────────────────────────────────────────────────────────────────────
// export default function FormatSelectionScreen({ loggedInUser, companyData, connectionString }) {
//     const API = connectionString;
//     const auth = useAuth();
//     const { selectedCompany } = useAuth();
//     const authSelectedCompany = auth?.selectedCompany ?? null;
//     const muiTheme = useTheme();
//     const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
//     const isTablet = useMediaQuery(muiTheme.breakpoints.down('md'));

//     const [selectedType, setSelectedType] = useState('');
//     const [selectedFormat, setSelectedFormat] = useState(null);
//     const [appliedFormat, setAppliedFormat] = useState(null);
//     const [previewOpen, setPreviewOpen] = useState(false);
//     const [snack, setSnack] = useState({ open: false, msg: '', severity: 'success' });

//     // Multi-series states
//     const [seriesList, setSeriesList] = useState([]);
//     const [selectedSeries, setSelectedSeries] = useState(null);
//     const [seriesFormats, setSeriesFormats] = useState({});
//     const [loadingSeries, setLoadingSeries] = useState(false);

//     const AppRegID = selectedCompany?.AppRegID || null;
//     const isMultiSeriesType = MULTI_SERIES_TYPES.includes(selectedType);

//     // ── Company resolution ────────────────────────────────────────────────────
//     const companyFromProp = Array.isArray(companyData) ? companyData[0] : (companyData || null);
//     let fallbackLS = null;
//     try {
//         const s = typeof window !== 'undefined' ? window.localStorage.getItem('selectedCompany') : null;
//         if (s) fallbackLS = JSON.parse(s);
//     } catch { fallbackLS = null; }

//     const companyObj = authSelectedCompany || companyFromProp
//         || (loggedInUser && (loggedInUser.selectedCompany || loggedInUser.company || loggedInUser.companyData))
//         || fallbackLS || {};

//     const tryNum = (v) => { if (v == null || v === '') return 0; const n = Number(v); return isFinite(n) ? n : 0; };
//     const GCompId_RAW = companyObj?.GCompId ?? companyObj?.GCompid ?? companyObj?.GCompID ?? null;
//     const GCompId = (GCompId_RAW == null || GCompId_RAW === '') ? null : tryNum(GCompId_RAW);

//     let CompId = 0;
//     for (const c of [companyObj?.CompId, companyObj?.CompID, companyObj?.Compid, companyObj?.CompanyId, loggedInUser?.CompId, loggedInUser?.CompanyId]) {
//         const n = tryNum(c);
//         if (n > 0) { CompId = n; break; }
//     }
//     if (!CompId && fallbackLS) {
//         for (const c of [fallbackLS?.CompId, fallbackLS?.CompID, fallbackLS?.CompanyId]) {
//             const n = tryNum(c);
//             if (n > 0) { CompId = n; break; }
//         }
//     }

//     const CURRENT_USER_ID = Number(loggedInUser?.UserId ?? loggedInUser?.UserID ?? 0);
//     const toMySqlDT = (d) => {
//         const p = (n) => String(n).padStart(2, '0');
//         return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
//     };

//     const getBookNameKey = (type, series = null) => {
//         const base = type.replace(/\s+/g, '');
//         if (series) {
//             const seriesId = series?.SeriesId || series?.SeriesID || series?.seriesId || series?.Id || series?.id || 0;
//             return `${base}_Series_${seriesId}`;
//         }
//         return base;
//     };

//     const getSeriesId = (series) => {
//         return series?.SeriesId || series?.SeriesID || series?.seriesId || series?.Id || series?.id || 0;
//     };

//     // ── Fetch series ──────────────────────────────────────────────────────────
//     const fetchSeriesForType = async (type) => {
//         setLoadingSeries(true);
//         setSeriesList([]);
//         setSelectedSeries(null);
//         setSeriesFormats({});
//         try {
//             const companyIdParam = CompId || 0;
//             const typeNorm = type.replace(/\s+/g, '');
//             const resp = await axios.get(`${API}/api/seriesForPDF`, {
//                 params: { companyId: companyIdParam, documentType: typeNorm },
//                 timeout: 15000,
//             });

//             let arr = [];
//             if (resp?.data) {
//                 if (Array.isArray(resp.data.series)) arr = resp.data.series;
//                 else if (Array.isArray(resp.data)) arr = resp.data;
//                 else if (Array.isArray(resp.data.data)) arr = resp.data.data;
//             }
//             setSeriesList(arr);

//             if (arr.length > 0) {
//                 try {
//                     const fmtResp = await axios.get(`${API}/api/companies`, {
//                         params: { companyId: companyIdParam },
//                         timeout: 15000,
//                     });
//                     let companies = [];
//                     if (fmtResp?.data) {
//                         if (Array.isArray(fmtResp.data.companies)) companies = fmtResp.data.companies;
//                         else if (Array.isArray(fmtResp.data)) companies = fmtResp.data;
//                         else if (Array.isArray(fmtResp.data.data)) companies = fmtResp.data.data;
//                     }
//                     const wantedId = Number(CompId || companyIdParam || 0);
//                     const rec = companies.find(c => tryNum(c?.CompId ?? c?.CompID ?? 0) === wantedId) || companies[0];
//                     if (rec && Array.isArray(rec.formats)) {
//                         const norm = (s) => String(s || '').replace(/\s+/g, '').toLowerCase();
//                         const fmtMap = {};
//                         for (const series of arr) {
//                             const sId = getSeriesId(series);
//                             const wantedBookName = norm(typeNorm);
//                             for (const f of rec.formats) {
//                                 const bName = norm(f?.BookName ?? '');
//                                 const bId = Number(f?.BookID ?? f?.BookId ?? 0);
//                                 const fSeriesId = Number(f?.SeriesId ?? f?.seriesId ?? 0);
//                                 if (bId && bName === wantedBookName && fSeriesId === Number(sId)) {
//                                     fmtMap[sId] = bId;
//                                     break;
//                                 }
//                             }
//                             if (!fmtMap[sId]) {
//                                 for (const f of rec.formats) {
//                                     const bName = norm(f?.BookName ?? '');
//                                     const bId = Number(f?.BookID ?? f?.BookId ?? 0);
//                                     const fSeriesId = Number(f?.SeriesId ?? f?.seriesId ?? 0);
//                                     if (bId && bName === wantedBookName && (!fSeriesId || fSeriesId === 0)) {
//                                         fmtMap[sId] = bId;
//                                         break;
//                                     }
//                                 }
//                             }
//                         }
//                         setSeriesFormats(fmtMap);
//                     }
//                 } catch (err) {
//                     console.warn('Error fetching series formats', err?.message);
//                 }
//             }
//         } catch (err) {
//             console.warn('Series API error', err?.response?.data || err?.message);
//             setSeriesList([]);
//             setSelectedSeries(null);
//             setSeriesFormats({});
//             setSnack({ open: true, msg: err?.response?.data?.message || 'Failed to load series.', severity: 'error' });
//         } finally {
//             setLoadingSeries(false);
//         }
//     };

//     // ── Handlers ─────────────────────────────────────────────────────────────
//     const handleSelectType = async (type) => {
//         setSelectedType(type);
//         setSelectedFormat(null);
//         setAppliedFormat(null);
//         setSelectedSeries(null);
//         setSeriesList([]);
//         setSeriesFormats({});

//         if (MULTI_SERIES_TYPES.includes(type)) {
//             await fetchSeriesForType(type);
//         } else {
//             try {
//                 const companyIdParam = CompId || 0;
//                 const resp = await axios.get(`${API}/api/companies`, { params: { companyId: companyIdParam }, timeout: 15000 });
//                 let arr = [];
//                 if (resp?.data) {
//                     if (Array.isArray(resp.data.companies)) arr = resp.data.companies;
//                     else if (Array.isArray(resp.data)) arr = resp.data;
//                     else if (Array.isArray(resp.data.data)) arr = resp.data.data;
//                 }
//                 const wantedId = Number(CompId || companyIdParam || 0);
//                 const rec = arr.find(c => tryNum(c?.CompId ?? c?.CompID ?? 0) === wantedId) || arr[0];
//                 if (rec && Array.isArray(rec.formats)) {
//                     const norm = (s) => String(s || '').replace(/\s+/g, '').toLowerCase();
//                     const wantedNorm = norm(type);
//                     let found = null;
//                     for (const f of rec.formats) {
//                         const bName = norm(f?.BookName ?? '');
//                         const bId = Number(f?.BookID ?? f?.BookId ?? 0);
//                         if (bId && bName === wantedNorm) { found = bId; break; }
//                     }
//                     setAppliedFormat(found ?? 1);
//                 } else {
//                     setAppliedFormat(1);
//                 }
//             } catch (err) {
//                 console.warn('companies API error', err?.message);
//             }
//         }
//     };

//     const handleSelectSeries = (series) => {
//         setSelectedSeries(series);
//         setSelectedFormat(null);
//         const sId = getSeriesId(series);
//         const fmt = seriesFormats[sId] || null;
//         setAppliedFormat(fmt);
//     };

//     const handleCardClick = (format) => {
//         setSelectedFormat(format);
//         setPreviewOpen(true);
//     };

//     const handleApplyTemplate = async () => {
//         if (!selectedType || !selectedFormat) {
//             setSnack({ open: true, msg: 'Select a document type and format first.', severity: 'warning' });
//             return;
//         }
//         if (isMultiSeriesType && !selectedSeries) {
//             setSnack({ open: true, msg: 'Please select a series first.', severity: 'warning' });
//             return;
//         }
//         if (!CompId) {
//             setSnack({ open: true, msg: 'Unable to determine your company. Please select a company first.', severity: 'error' });
//             return;
//         }
//         const now = new Date();
//         const bookName = selectedType.replace(/\s+/g, '');
//         const seriesId = isMultiSeriesType ? getSeriesId(selectedSeries) : null;

//         const payload = {
//             GCompId: null, CompId,
//             BookName: bookName,
//             BookID: Number(selectedFormat),
//             FormName: isMultiSeriesType
//                 ? `${selectedType}-Series-${seriesId}-Format-${selectedFormat}`
//                 : `${selectedType}-Format-${selectedFormat}`,
//             CompDefault: 0, PPO: 0,
//             paperheight: 842, paperwidth: 595,
//             TopMargin: 0, LeftMargin: 0, RightMargin: 0, BottomMargin: 0,
//             Heading: '',
//             AddUserId: CURRENT_USER_ID, AddUserDateTime: toMySqlDT(now),
//             EditUserId: CURRENT_USER_ID, EditUserDateTime: toMySqlDT(now),
//             AppRegID,
//             ...(isMultiSeriesType && seriesId ? { SeriesId: seriesId } : {}),
//         };
//         try {
//             const res = await axios.post(`${API}/api/printmaster`, payload, { headers: { 'Content-Type': 'application/json' }, timeout: 15000 });
//             const ok = res?.data?.success === true || res?.data?.insertId || (res?.data?.affectedRows > 0);
//             if (ok) {
//                 const newFormat = Number(selectedFormat);
//                 setAppliedFormat(newFormat);
//                 if (isMultiSeriesType && selectedSeries) {
//                     const sId = getSeriesId(selectedSeries);
//                     setSeriesFormats(prev => ({ ...prev, [sId]: newFormat }));
//                 }
//                 setPreviewOpen(false);
//                 setSelectedFormat(null);
//                 const seriesLabel = isMultiSeriesType && selectedSeries
//                     ? ` for ${selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || 'series'}`
//                     : '';
//                 setSnack({ open: true, msg: `Format ${selectedFormat} applied successfully${seriesLabel}!`, severity: 'success' });
//             } else {
//                 setSnack({ open: true, msg: res?.data?.message || 'Failed to apply template.', severity: 'error' });
//             }
//         } catch (err) {
//             const msg = err.response?.data?.message || `Server error ${err.response?.status || ''}` || 'Network error.';
//             setSnack({ open: true, msg, severity: 'error' });
//         }
//     };

//     const showFormatGrid = selectedType && (!isMultiSeriesType || (isMultiSeriesType && selectedSeries));

//     const getActiveFormatLabel = () => {
//         if (isMultiSeriesType && selectedSeries) {
//             const sId = getSeriesId(selectedSeries);
//             const fmt = seriesFormats[sId];
//             if (fmt) {
//                 const sName = selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || `Series ${sId}`;
//                 return `Format ${fmt} — ${sName}`;
//             }
//             return null;
//         }
//         if (appliedFormat && selectedType && !isMultiSeriesType) return `Format ${appliedFormat} active`;
//         return null;
//     };

//     const activeLabel = getActiveFormatLabel();

//     // ─── RENDER ───────────────────────────────────────────────────────────────
//     return (
//         <Box sx={{ minHeight: "100vh", background: BG }}>

//             {/* ── TOPBAR ── */}
//             <Box sx={{
//                 background: "#fff", borderBottom: `0.5px solid ${BORDER}`,
//                 px: { xs: 2, sm: 3, md: 4 }, py: 1.5,
//                 display: "flex", alignItems: "center", justifyContent: "space-between",
//             }}>
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
//                     <Box sx={{
//                         width: 36, height: 36, background: FB, borderRadius: "9px",
//                         display: "flex", alignItems: "center", justifyContent: "center"
//                     }}>
//                         <FilePresent sx={{ color: "#fff", fontSize: 19 }} />
//                     </Box>
//                     <Box>
//                         <Typography sx={{ fontSize: 16, fontWeight: 500, color: T1, lineHeight: 1.2 }}>
//                             Printing <Box component="span" sx={{ color: FB }}>utilities</Box>
//                         </Typography>
//                         <Typography sx={{ fontSize: 11, color: T2 }}>
//                             Document template manager
//                         </Typography>
//                     </Box>
//                 </Box>
//                 {activeLabel && (
//                     <Box sx={{
//                         display: "flex", alignItems: "center", gap: "6px",
//                         px: "10px", py: "4px", bgcolor: GREEN_LT, borderRadius: "20px",
//                         border: `0.5px solid ${GREEN}44`,
//                     }}>
//                         <CheckCircle sx={{ fontSize: 13, color: GREEN }} />
//                         <Typography sx={{ fontSize: 12, fontWeight: 500, color: GREEN }}>
//                             {activeLabel}
//                         </Typography>
//                     </Box>
//                 )}
//             </Box>

//             {/* ── CONTENT ── */}
//             <Box sx={{ maxWidth: 1200, mx: "auto", px: { xs: 1.5, sm: 3, md: 4 }, py: { xs: 2, sm: 3, md: 4 } }}>

//                 {/* ── Step 1 — Type selector ── */}
//                 <Box sx={{ ...cardBaseSx, p: { xs: 1.5, sm: 2 }, mb: { xs: 1.5, sm: 2 } }}>
//                     <Typography sx={{
//                         fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".4px", mb: 1,
//                         display: "flex", alignItems: "center", gap: "6px"
//                     }}>
//                         <Box component="span" sx={{ width: 14, height: 14, bgcolor: FB, borderRadius: "4px", display: "inline-block" }} />
//                         Step 1 — Select document type
//                     </Typography>

//                     <FormControl fullWidth size="small">
//                         <Select value={selectedType} onChange={(e) => handleSelectType(e.target.value)}
//                             displayEmpty IconComponent={KeyboardArrowDown}
//                             renderValue={(val) => val || (
//                                 <Typography sx={{ fontSize: 13, color: T2 }}>Select a document type…</Typography>
//                             )}
//                             sx={{
//                                 bgcolor: BG, borderRadius: "8px", fontSize: 13,
//                                 "& .MuiOutlinedInput-notchedOutline": { borderColor: BORDER },
//                                 "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: FB_MID },
//                                 "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: FB, borderWidth: 2 },
//                                 "& .MuiSelect-select": { py: 1.25, px: 1.5, fontSize: 13, fontWeight: 500, color: T1 },
//                             }}
//                             MenuProps={{
//                                 PaperProps: {
//                                     sx: {
//                                         borderRadius: "10px", mt: 0.5,
//                                         border: `0.5px solid ${BORDER}`,
//                                         boxShadow: "0 8px 24px rgba(24,119,242,0.10)",
//                                     }
//                                 }
//                             }}
//                         >
//                             {documentTypes.map((type) => (
//                                 <MenuItem key={type} value={type}
//                                     sx={{
//                                         fontSize: 13, fontWeight: 500, color: T1, py: 1.25, px: 2, gap: 1.5,
//                                         "&:hover": { bgcolor: FB_LIGHT },
//                                         "&.Mui-selected": { bgcolor: FB_LIGHT, color: FB },
//                                         "&.Mui-selected:hover": { bgcolor: FB_LIGHT },
//                                     }}
//                                 >
//                                     <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: FB, flexShrink: 0 }} />
//                                     {type}
//                                     {MULTI_SERIES_TYPES.includes(type) && (
//                                         <Chip
//                                             label="Multi-series"
//                                             size="small"
//                                             sx={{
//                                                 ml: "auto", fontSize: 10, height: 20,
//                                                 bgcolor: FB_LIGHT, color: FB,
//                                                 border: `0.5px solid ${FB_MID}`,
//                                             }}
//                                         />
//                                     )}
//                                 </MenuItem>
//                             ))}
//                         </Select>
//                     </FormControl>
//                 </Box>

//                 {/* ── Step 1.5 — Series selector ── */}
//                 {isMultiSeriesType && selectedType && (
//                     <Fade in={isMultiSeriesType}>
//                         <Box sx={{ ...cardBaseSx, p: { xs: 1.5, sm: 2 }, mb: { xs: 1.5, sm: 2 } }}>
//                             <Typography sx={{
//                                 fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".4px", mb: 1,
//                                 display: "flex", alignItems: "center", gap: "6px"
//                             }}>
//                                 <Box component="span" sx={{ width: 14, height: 14, bgcolor: FB, borderRadius: "4px", display: "inline-block" }} />
//                                 Step 2 — Select series
//                                 <Chip
//                                     label="Multi-series document"
//                                     size="small"
//                                     sx={{
//                                         ml: 1, fontSize: 10, height: 20,
//                                         bgcolor: FB_LIGHT, color: FB,
//                                         border: `0.5px solid ${FB_MID}`,
//                                     }}
//                                 />
//                             </Typography>
//                             <Typography sx={{ fontSize: 13, color: T2, mb: 1.5 }}>
//                                 This document type supports multiple series. Select a series to set its format individually.
//                             </Typography>

//                             {loadingSeries ? (
//                                 <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", py: 4, gap: 1.5 }}>
//                                     <CircularProgress size={24} sx={{ color: FB }} />
//                                     <Typography sx={{ fontSize: 13, color: T2 }}>Loading series…</Typography>
//                                 </Box>
//                             ) : seriesList.length > 0 ? (
//                                 <Grid container spacing={{ xs: 1, sm: 1.5 }}>
//                                     {seriesList.map((series, index) => {
//                                         const sId = getSeriesId(series);
//                                         const isSelected = selectedSeries && getSeriesId(selectedSeries) === sId;
//                                         const sAppliedFormat = seriesFormats[sId] || null;
//                                         return (
//                                             <Grid item key={sId} xs={12} sm={6} md={4}>
//                                                 <SeriesCard
//                                                     series={series}
//                                                     isSelected={isSelected}
//                                                     appliedFormat={sAppliedFormat}
//                                                     onClick={handleSelectSeries}
//                                                     index={index}
//                                                 />
//                                             </Grid>
//                                         );
//                                     })}
//                                 </Grid>
//                             ) : (
//                                 <Box sx={{
//                                     py: 4, textAlign: "center",
//                                     border: `1.5px dashed ${BORDER}`, borderRadius: "10px",
//                                 }}>
//                                     <Box sx={{
//                                         width: 44, height: 44, bgcolor: FB_LIGHT, borderRadius: "11px",
//                                         display: "flex", alignItems: "center", justifyContent: "center",
//                                         mx: "auto", mb: 1,
//                                     }}>
//                                         <BarChart sx={{ fontSize: 22, color: FB_MID }} />
//                                     </Box>
//                                     <Typography sx={{ fontSize: 14, fontWeight: 500, color: T1, mb: "4px" }}>
//                                         No series found
//                                     </Typography>
//                                     <Typography sx={{ fontSize: 12, color: T2 }}>
//                                         No series available for {selectedType}. Please create a series first.
//                                     </Typography>
//                                 </Box>
//                             )}

//                             {seriesList.length > 0 && Object.keys(seriesFormats).length > 0 && (
//                                 <Box sx={{
//                                     mt: 2, p: 1.5, bgcolor: BG, borderRadius: "8px",
//                                     border: `0.5px solid ${BORDER}`,
//                                 }}>
//                                     <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: 1, letterSpacing: ".3px" }}>
//                                         FORMAT SUMMARY
//                                     </Typography>
//                                     <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                                         {seriesList.map((series) => {
//                                             const sId = getSeriesId(series);
//                                             const sName = series?.SeriesName || series?.seriesName || series?.Name || series?.name || `Series ${sId}`;
//                                             const fmt = seriesFormats[sId];
//                                             return (
//                                                 <Chip
//                                                     key={sId}
//                                                     icon={fmt ? <CheckCircle sx={{ fontSize: 12, color: `${GREEN} !important` }} /> : undefined}
//                                                     label={`${sName}: ${fmt ? `Format ${fmt}` : 'Not set'}`}
//                                                     size="small"
//                                                     sx={{
//                                                         fontSize: 11, height: 24,
//                                                         bgcolor: fmt ? GREEN_LT : "#fff",
//                                                         color: fmt ? GREEN : T2,
//                                                         border: `0.5px solid ${fmt ? GREEN + '44' : BORDER}`,
//                                                         "& .MuiChip-icon": { ml: "6px" },
//                                                     }}
//                                                 />
//                                             );
//                                         })}
//                                     </Box>
//                                 </Box>
//                             )}
//                         </Box>
//                     </Fade>
//                 )}

//                 {/* ── Step 2/3 — Format grid ── */}
//                 {showFormatGrid ? (
//                     <Fade in={showFormatGrid}>
//                         <Box>
//                             <Box sx={{
//                                 ...cardBaseSx, px: { xs: 1.5, sm: 2 }, py: 1.5,
//                                 mb: { xs: 1.5, sm: 2 },
//                                 display: "flex", alignItems: "center", justifyContent: "space-between",
//                                 flexWrap: "wrap", gap: 1
//                             }}>
//                                 <Box>
//                                     <Typography sx={{
//                                         fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".4px", mb: "2px",
//                                         display: "flex", alignItems: "center", gap: "6px"
//                                     }}>
//                                         <Box component="span" sx={{ width: 14, height: 14, bgcolor: FB, borderRadius: "4px", display: "inline-block" }} />
//                                         Step {isMultiSeriesType ? '3' : '2'} — Choose format
//                                     </Typography>
//                                     <Typography sx={{ fontSize: 15, fontWeight: 500, color: T1 }}>
//                                         {selectedType} templates
//                                         {isMultiSeriesType && selectedSeries && (
//                                             <Box component="span" sx={{
//                                                 ml: 1, fontSize: 12, color: FB, fontWeight: 500,
//                                                 px: "8px", py: "2px", bgcolor: FB_LIGHT, borderRadius: "12px",
//                                                 border: `0.5px solid ${FB_MID}`,
//                                             }}>
//                                                 {selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || selectedSeries?.name || 'Selected Series'}
//                                             </Box>
//                                         )}
//                                         <Box component="span" sx={{ ml: 1, fontSize: 12, color: T2, fontWeight: 400 }}>
//                                             ({FORMAT_COUNT} available)
//                                         </Box>
//                                     </Typography>
//                                 </Box>
//                                 {appliedFormat && (
//                                     <Box sx={{
//                                         display: "inline-flex", alignItems: "center", gap: "6px",
//                                         px: "10px", py: "4px", bgcolor: GREEN_LT, borderRadius: "20px",
//                                         border: `0.5px solid ${GREEN}44`
//                                     }}>
//                                         <CheckCircle sx={{ fontSize: 13, color: GREEN }} />
//                                         <Typography sx={{ fontSize: 12, fontWeight: 500, color: GREEN }}>
//                                             Format {appliedFormat} is active
//                                             {isMultiSeriesType && selectedSeries && (
//                                                 <Box component="span" sx={{ ml: 0.5, fontSize: 11, color: GREEN, opacity: 0.8 }}>
//                                                     for this series
//                                                 </Box>
//                                             )}
//                                         </Typography>
//                                     </Box>
//                                 )}
//                             </Box>

//                             <Grid container spacing={{ xs: 1.25, sm: 2 }}>
//                                 {formats.map((format) => (
//                                     <Grid item key={format} xs={6} sm={4} md={3}>
//                                         <FormatCard
//                                             format={format}
//                                             selectedType={selectedType}
//                                             isApplied={appliedFormat === format}
//                                             onClick={() => handleCardClick(format)}
//                                         />
//                                     </Grid>
//                                 ))}
//                             </Grid>
//                         </Box>
//                     </Fade>
//                 ) : !selectedType ? (
//                     <Box sx={{
//                         ...cardBaseSx, py: { xs: 6, sm: 8 }, textAlign: "center",
//                         border: `1.5px dashed ${BORDER}`,
//                     }}>
//                         <Box sx={{
//                             width: 52, height: 52, bgcolor: FB_LIGHT, borderRadius: "13px",
//                             display: "flex", alignItems: "center", justifyContent: "center",
//                             mx: "auto", mb: 1.5,
//                         }}>
//                             <FilePresent sx={{ fontSize: 26, color: FB_MID }} />
//                         </Box>
//                         <Typography sx={{ fontSize: 15, fontWeight: 500, color: T1, mb: "4px" }}>
//                             No document type selected
//                         </Typography>
//                         <Typography sx={{ fontSize: 13, color: T2 }}>
//                             Select a type above to browse {FORMAT_COUNT} professional templates
//                         </Typography>
//                     </Box>
//                 ) : isMultiSeriesType && !selectedSeries ? (
//                     !loadingSeries && seriesList.length > 0 && (
//                         <Box sx={{
//                             ...cardBaseSx, py: { xs: 5, sm: 6 }, textAlign: "center",
//                             border: `1.5px dashed ${BORDER}`,
//                         }}>
//                             <Box sx={{
//                                 width: 52, height: 52, bgcolor: FB_LIGHT, borderRadius: "13px",
//                                 display: "flex", alignItems: "center", justifyContent: "center",
//                                 mx: "auto", mb: 1.5,
//                             }}>
//                                 <BarChart sx={{ fontSize: 26, color: FB_MID }} />
//                             </Box>
//                             <Typography sx={{ fontSize: 15, fontWeight: 500, color: T1, mb: "4px" }}>
//                                 Select a series to continue
//                             </Typography>
//                             <Typography sx={{ fontSize: 13, color: T2 }}>
//                                 Choose a series from above to set its template format
//                             </Typography>
//                         </Box>
//                     )
//                 ) : null}
//             </Box>

//             {/* ── Preview dialog ── */}
//             <PreviewDialog
//                 open={previewOpen}
//                 onClose={() => { setPreviewOpen(false); setSelectedFormat(null); }}
//                 selectedType={selectedType}
//                 selectedFormat={selectedFormat}
//                 appliedFormat={appliedFormat}
//                 onApply={handleApplyTemplate}
//                 selectedSeries={selectedSeries}
//             />

//             {/* ── Snackbar ── */}
//             <Snackbar open={snack.open} autoHideDuration={3000}
//                 onClose={() => setSnack(s => ({ ...s, open: false }))}
//                 anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//             >
//                 <Alert severity={snack.severity} variant="filled"
//                     onClose={() => setSnack(s => ({ ...s, open: false }))}
//                     sx={{ borderRadius: "8px", fontWeight: 500 }}
//                 >
//                     {snack.msg}
//                 </Alert>
//             </Snackbar>
//         </Box>
//     );
// }







// import React, { useRef, useState, useEffect, useCallback } from 'react';
// import axios from 'axios';
// import { useAuth } from '../context/AuthContext';
// import {
//     Box, Typography, Grid, Card, CardMedia, CardContent, Chip, MenuItem, Select,
//     FormControl, Dialog, DialogContent, Button, IconButton, Snackbar, Alert, Fade,
//     Zoom, Skeleton, Tooltip, useTheme, useMediaQuery, CircularProgress
// } from '@mui/material';
// import {
//     CheckCircle, Close, ZoomIn, ZoomOut, OpenInFull, FilePresent, KeyboardArrowDown,
//     AutoAwesome, BarChart
// } from '@mui/icons-material';

// // ─── DESIGN TOKENS ────────────────────────────────────────────────────────────
// const FB = "#1877F2";
// const FB_DARK = "#0C5FD6";
// const FB_LIGHT = "#E7F0FD";
// const FB_MID = "#B3CFF9";
// const BG = "#F0F4FF";
// const BORDER = "#DCE3F5";
// const T1 = "#0F1B35";
// const T2 = "#5A6A8A";
// const GREEN = "#1a9e5c";
// const GREEN_LT = "#e6f7ef";
// const RED = "#E24B4A";

// // ─── CONSTANTS ────────────────────────────────────────────────────────────────
// const publicUrl = typeof process !== 'undefined' && process.env?.PUBLIC_URL ? process.env.PUBLIC_URL : '';
// const dummyImg = `${publicUrl}/Quotation_Image.jpeg`;

// // ✅ NEW: Format configuration for different document types
// const FORMAT_CONFIG = {
//     'Quotation': 10,
//     'Proforma Invoice': 10,
//     'Sale Challan': 13,
//     'Sale Invoice': 10,
//     'Purchase Order': 10,
//     'Purchase Dispatch': 13,
//     'Purchase Invoice': 10,
//     'Credit Note': 10,
//     'Debit Note': 10,
// };

// // ✅ NEW: Get format count for any document type
// const getFormatCount = (type) => {
//     return FORMAT_CONFIG[type] || 10;
// };

// const getImageForTypeFormat = (type = '', format = 0) => {
//     const idx = Number(format) || 0;
//     if (!idx || idx < 1 || idx > 20) return { thumb: dummyImg, large: dummyImg };
//     const norm = (type || '').replace(/\s+/g, '').toLowerCase();
//     const build = (base) => `${publicUrl}/${base}${idx}.jpg`;
//     const map = {
//         quotation: () => build('Quotation'),
//         saleorder: () => build('SaleOrder'),
//         proformainvoice: () => build('ProformaInvoice'),
//         salechallan: () => build('SaleChallan'),
//         saleinvoice: () => build('SaleInvoice'),
//         creditnote: () => build('CreditNote'),
//         purchaseorder: () => build('PurchaseOrder'),
//         purchasedispatch: () => build('PurchaseChallan'),
//         purchaseinvoice: () => build('PurchaseInvoice'),
//         debitnote: () => build('DebitNote'),
//     };
//     const src = map[norm] ? map[norm]() : dummyImg;
//     return { thumb: src, large: src };
// };

// const documentTypes = [
//     'Quotation',
//     'Proforma Invoice',
//     'Sale Challan',
//     'Sale Invoice',
// ];

// // Document types that support multiple series
// const MULTI_SERIES_TYPES = ['Sale Challan', 'Sale Invoice', 'Proforma Invoice', 'Credit Note'];

// const FORMAT_COUNT = 10;
// const formats = Array.from({ length: FORMAT_COUNT }, (_, i) => i + 1);

// // ─── SHARED SX ────────────────────────────────────────────────────────────────
// const cardBaseSx = {
//     background: "#fff", border: `0.5px solid ${BORDER}`, borderRadius: "12px",
// };

// const btnPrimarySx = {
//     background: FB, color: "#fff", borderRadius: "8px", fontSize: 13, fontWeight: 500,
//     textTransform: "none", px: 2.5, height: 38,
//     "&:hover": { background: FB_DARK },
//     "&:disabled": { background: FB_MID, color: "#fff" },
// };

// const btnGhostSx = {
//     background: "transparent", color: T2, border: `0.5px solid ${BORDER}`, borderRadius: "8px",
//     fontSize: 13, fontWeight: 500, textTransform: "none", px: 2.5, height: 38,
//     "&:hover": { background: "#fff", color: T1 },
// };

// // ─── SERIES CARD ──────────────────────────────────────────────────────────────
// function SeriesCard({ series, isSelected, appliedFormat, onClick, index }) {
//     const seriesName = series?.SeriesName || series?.seriesName || series?.Name || series?.name || `Series ${series?.SeriesId || series?.SeriesID || index + 1}`;
//     const seriesId = series?.SeriesId || series?.SeriesID || series?.seriesId || series?.Id || series?.id || index + 1;

//     return (
//         <Zoom in style={{ transitionDelay: `${index * 40}ms` }}>
//             <Card
//                 onClick={() => onClick(series)}
//                 sx={{
//                     cursor: "pointer", borderRadius: "12px", overflow: "hidden",
//                     border: isSelected ? `2px solid ${FB}` : `0.5px solid ${BORDER}`,
//                     outline: isSelected ? `4px solid ${FB_LIGHT}` : "none",
//                     boxShadow: "none", transition: "all 0.2s ease",
//                     "&:hover": {
//                         boxShadow: `0 6px 24px rgba(24,119,242,0.14)`,
//                         transform: "translateY(-4px)", borderColor: FB,
//                     },
//                     background: "#fff", p: 2,
//                 }}
//             >
//                 <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//                         <Box sx={{
//                             width: 40, height: 40, borderRadius: "10px",
//                             bgcolor: isSelected ? FB : FB_LIGHT,
//                             display: "flex", alignItems: "center", justifyContent: "center",
//                             transition: "all 0.2s ease",
//                         }}>
//                             <BarChart sx={{ fontSize: 20, color: isSelected ? "#fff" : FB }} />
//                         </Box>
//                         <Box>
//                             <Typography sx={{ fontSize: 14, fontWeight: 500, color: T1, lineHeight: 1.3 }}>
//                                 {seriesName}
//                             </Typography>
//                             <Typography sx={{ fontSize: 11, color: T2 }}>
//                                 Series ID: {seriesId}
//                             </Typography>
//                         </Box>
//                     </Box>
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                         {appliedFormat && (
//                             <Chip
//                                 icon={<CheckCircle sx={{ fontSize: 13, color: `${GREEN} !important` }} />}
//                                 label={`Format ${appliedFormat}`}
//                                 size="small"
//                                 sx={{
//                                     fontSize: 11, fontWeight: 500, height: 24,
//                                     bgcolor: GREEN_LT, color: GREEN,
//                                     border: `0.5px solid ${GREEN}44`,
//                                     "& .MuiChip-icon": { ml: "6px" },
//                                 }}
//                             />
//                         )}
//                         {isSelected && (
//                             <Box sx={{
//                                 width: 24, height: 24, borderRadius: "50%", bgcolor: FB,
//                                 display: "flex", alignItems: "center", justifyContent: "center",
//                             }}>
//                                 <CheckCircle sx={{ color: "#fff", fontSize: 16 }} />
//                             </Box>
//                         )}
//                     </Box>
//                 </Box>
//             </Card>
//         </Zoom>
//     );
// }

// // ─── FORMAT CARD ──────────────────────────────────────────────────────────────
// function FormatCard({ format, selectedType, isApplied, onClick }) {
//     const [imgLoaded, setImgLoaded] = useState(false);
//     const { thumb } = getImageForTypeFormat(selectedType, format);

//     return (
//         <Zoom in style={{ transitionDelay: `${(format - 1) * 40}ms` }}>
//             <Card
//                 onClick={onClick}
//                 sx={{
//                     cursor: "pointer", borderRadius: "12px", overflow: "hidden",
//                     border: isApplied ? `2px solid ${FB}` : `0.5px solid ${BORDER}`,
//                     outline: isApplied ? `4px solid ${FB_LIGHT}` : "none",
//                     boxShadow: "none", transition: "all 0.2s ease",
//                     "&:hover": {
//                         boxShadow: `0 6px 24px rgba(24,119,242,0.14)`,
//                         transform: "translateY(-4px)", borderColor: FB,
//                     },
//                     position: "relative", background: "#fff",
//                 }}
//             >
//                 <Box sx={{ position: "relative", bgcolor: BG, height: { xs: 160, sm: 200, md: 220 }, overflow: "hidden" }}>
//                     {!imgLoaded && (
//                         <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" sx={{ bgcolor: FB_LIGHT }} />
//                     )}
//                     <CardMedia component="img" image={thumb} alt={`Format ${format}`}
//                         onLoad={() => setImgLoaded(true)}
//                         onError={(e) => { e.currentTarget.src = dummyImg; setImgLoaded(true); }}
//                         sx={{
//                             height: "100%", objectFit: "cover",
//                             display: imgLoaded ? "block" : "none",
//                             transition: "transform 0.3s ease",
//                             "&:hover": { transform: "scale(1.04)" },
//                         }}
//                     />
//                     <Box sx={{
//                         position: "absolute", inset: 0,
//                         background: "linear-gradient(to top, rgba(24,119,242,0.25) 0%, transparent 50%)",
//                         pointerEvents: "none",
//                     }} />
//                     <Box sx={{
//                         position: "absolute", top: 10, left: 10, px: "8px", py: "3px",
//                         background: isApplied ? FB : "rgba(255,255,255,0.9)",
//                         borderRadius: "6px", border: `0.5px solid ${isApplied ? FB : BORDER}`,
//                     }}>
//                         <Typography sx={{ fontSize: 11, fontWeight: 500, color: isApplied ? "#fff" : T2 }}>
//                             Format {format}
//                         </Typography>
//                     </Box>
//                     {isApplied && (
//                         <Box sx={{
//                             position: "absolute", top: 10, right: 10,
//                             width: 28, height: 28, borderRadius: "50%",
//                             bgcolor: GREEN, display: "flex",
//                             alignItems: "center", justifyContent: "center",
//                         }}>
//                             <CheckCircle sx={{ color: "#fff", fontSize: 18 }} />
//                         </Box>
//                     )}
//                 </Box>
//                 <CardContent sx={{ py: 1.25, px: 1.5, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//                     <Typography sx={{ fontSize: 13, fontWeight: 500, color: T1 }}>
//                         Format {format}
//                     </Typography>
//                     {isApplied ? (
//                         <Chip
//                             icon={<CheckCircle sx={{ fontSize: 14, color: `${GREEN} !important` }} />}
//                             label="Active"
//                             size="small"
//                             sx={{
//                                 fontSize: 11, fontWeight: 500, height: 22,
//                                 bgcolor: GREEN_LT, color: GREEN,
//                                 border: `0.5px solid ${GREEN}44`,
//                                 "& .MuiChip-icon": { ml: "6px" },
//                             }}
//                         />
//                     ) : (
//                         <Chip
//                             label="Preview"
//                             size="small"
//                             sx={{
//                                 fontSize: 11, height: 22,
//                                 bgcolor: FB_LIGHT, color: FB,
//                                 border: `0.5px solid ${FB_MID}`,
//                             }}
//                         />
//                     )}
//                 </CardContent>
//             </Card>
//         </Zoom>
//     );
// }

// // ─── PREVIEW DIALOG ───────────────────────────────────────────────────────────
// function PreviewDialog({ open, onClose, selectedType, selectedFormat, onApply, appliedFormat, selectedSeries }) {

//     // ── All values stored in refs so event listeners always see latest values ──
//     const scaleRef = useRef(1);
//     const originRef = useRef({ x: 50, y: 50 });
//     const translateRef = useRef({ x: 0, y: 0 });
//     const isDraggingRef = useRef(false);
//     const dragStartRef = useRef({ mouseX: 0, mouseY: 0, translateX: 0, translateY: 0 });

//     // ── React state only for triggering re-renders ──
//     const [scale, setScale] = useState(1);
//     const [origin, setOrigin] = useState({ x: 50, y: 50 });
//     const [translate, setTranslate] = useState({ x: 0, y: 0 });
//     const [isDragging, setIsDragging] = useState(false);

//     const containerRef = useRef(null);

//     const { large } = getImageForTypeFormat(selectedType, selectedFormat);
//     const isAlreadyApplied = appliedFormat === selectedFormat;
//     const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'));
//     const isMultiSeries = MULTI_SERIES_TYPES.includes(selectedType);
//     const seriesName = selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || selectedSeries?.name || '';

//     // ── Master reset ──────────────────────────────────────────────────────────
//     const resetAll = useCallback(() => {
//         scaleRef.current = 1;
//         originRef.current = { x: 50, y: 50 };
//         translateRef.current = { x: 0, y: 0 };
//         isDraggingRef.current = false;
//         setScale(1);
//         setOrigin({ x: 50, y: 50 });
//         setTranslate({ x: 0, y: 0 });
//         setIsDragging(false);
//     }, []);

//     // ── Reset when dialog closes ──────────────────────────────────────────────
//     useEffect(() => {
//         if (!open) resetAll();
//     }, [open, resetAll]);

//     // ── Get pointer position as % inside the container ────────────────────────
//     const getPointerOrigin = useCallback((clientX, clientY) => {
//         const container = containerRef.current;
//         if (!container) return { x: 50, y: 50 };
//         const rect = container.getBoundingClientRect();
//         const x = Math.min(Math.max(((clientX - rect.left) / rect.width) * 100, 0), 100);
//         const y = Math.min(Math.max(((clientY - rect.top) / rect.height) * 100, 0), 100);
//         return { x, y };
//     }, []);

//     // ── Core zoom function — reads/writes refs, then syncs state ──────────────
//     const applyZoom = useCallback((delta, pointerOrigin) => {
//         const newScale = Math.min(Math.max(scaleRef.current * delta, 0.4), 5);
//         scaleRef.current = newScale;

//         if (pointerOrigin) {
//             originRef.current = pointerOrigin;
//             setOrigin({ ...pointerOrigin });
//         }

//         // Auto-reset translation when fully zoomed out
//         if (newScale <= 1) {
//             translateRef.current = { x: 0, y: 0 };
//             setTranslate({ x: 0, y: 0 });
//         }

//         setScale(newScale);
//     }, []);

//     // ── Wheel handler — defined with useCallback so it is stable ─────────────
//     const handleWheel = useCallback((e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         const po = getPointerOrigin(e.clientX, e.clientY);
//         const delta = e.deltaY > 0 ? 0.93 : 1.07;
//         applyZoom(delta, po);
//     }, [getPointerOrigin, applyZoom]);

//     // ── Attach wheel listener with { passive: false } on the container ────────
//     // Re-attach whenever handleWheel changes (it's stable, so this runs once per open)
//     useEffect(() => {
//         const el = containerRef.current;
//         if (!el || !open) return;
//         el.addEventListener('wheel', handleWheel, { passive: false });
//         return () => {
//             el.removeEventListener('wheel', handleWheel);
//         };
//     }, [open, handleWheel]);

//     // ── Button zoom — uses last known pointer origin ──────────────────────────
//     const handleZoomIn = useCallback(() => {
//         applyZoom(1.25, originRef.current);
//     }, [applyZoom]);

//     const handleZoomOut = useCallback(() => {
//         applyZoom(0.8, originRef.current);
//     }, [applyZoom]);

//     const handleReset = useCallback(() => {
//         resetAll();
//     }, [resetAll]);

//     // ── Mouse move — track pointer for button-zoom aim + handle drag ──────────
//     const handleMouseMove = useCallback((e) => {
//         if (!isDraggingRef.current) {
//             // Keep origin ref updated so button zooms aim at cursor
//             originRef.current = getPointerOrigin(e.clientX, e.clientY);
//             return;
//         }
//         // While dragging compute new translation
//         const dx = e.clientX - dragStartRef.current.mouseX;
//         const dy = e.clientY - dragStartRef.current.mouseY;
//         const newTranslate = {
//             x: dragStartRef.current.translateX + dx,
//             y: dragStartRef.current.translateY + dy,
//         };
//         translateRef.current = newTranslate;
//         setTranslate({ ...newTranslate });
//     }, [getPointerOrigin]);

//     // ── Mouse down — begin drag only when zoomed in ───────────────────────────
//     const handleMouseDown = useCallback((e) => {
//         if (scaleRef.current <= 1) return;
//         e.preventDefault();
//         isDraggingRef.current = true;
//         setIsDragging(true);
//         dragStartRef.current = {
//             mouseX: e.clientX,
//             mouseY: e.clientY,
//             translateX: translateRef.current.x,
//             translateY: translateRef.current.y,
//         };
//     }, []);

//     // ── Mouse up — stop drag the instant button is released ──────────────────
//     const handleMouseUp = useCallback(() => {
//         if (!isDraggingRef.current) return;
//         isDraggingRef.current = false;
//         setIsDragging(false);
//     }, []);

//     // ── Mouse leave — stop drag so image never gets stuck ────────────────────
//     const handleMouseLeave = useCallback(() => {
//         if (!isDraggingRef.current) return;
//         isDraggingRef.current = false;
//         setIsDragging(false);
//     }, []);

//     // ── Touch handlers (mobile) ───────────────────────────────────────────────
//     const handleTouchStart = useCallback((e) => {
//         if (scaleRef.current <= 1 || e.touches.length !== 1) return;
//         const touch = e.touches[0];
//         isDraggingRef.current = true;
//         setIsDragging(true);
//         dragStartRef.current = {
//             mouseX: touch.clientX,
//             mouseY: touch.clientY,
//             translateX: translateRef.current.x,
//             translateY: translateRef.current.y,
//         };
//     }, []);

//     const handleTouchMove = useCallback((e) => {
//         if (!isDraggingRef.current || e.touches.length !== 1) return;
//         e.preventDefault();
//         const touch = e.touches[0];
//         const dx = touch.clientX - dragStartRef.current.mouseX;
//         const dy = touch.clientY - dragStartRef.current.mouseY;
//         const newTranslate = {
//             x: dragStartRef.current.translateX + dx,
//             y: dragStartRef.current.translateY + dy,
//         };
//         translateRef.current = newTranslate;
//         setTranslate({ ...newTranslate });
//     }, []);

//     const handleTouchEnd = useCallback(() => {
//         isDraggingRef.current = false;
//         setIsDragging(false);
//     }, []);

//     // ── Attach touchmove with { passive: false } so preventDefault works ──────
//     useEffect(() => {
//         const el = containerRef.current;
//         if (!el || !open) return;
//         el.addEventListener('touchmove', handleTouchMove, { passive: false });
//         return () => {
//             el.removeEventListener('touchmove', handleTouchMove);
//         };
//     }, [open, handleTouchMove]);

//     // ─────────────────────────────────────────────────────────────────────────
//     return (
//         <Dialog
//             open={open}
//             onClose={onClose}
//             maxWidth="md"
//             fullWidth
//             fullScreen={isMobile}
//             TransitionComponent={Fade}
//             PaperProps={{
//                 sx: {
//                     borderRadius: isMobile ? 0 : "14px",
//                     overflow: "hidden",
//                     maxHeight: isMobile ? "100vh" : "92vh",
//                     border: `0.5px solid ${BORDER}`,
//                 }
//             }}
//         >
//             {/* ── Header ── */}
//             <Box sx={{
//                 display: "flex", alignItems: "center", justifyContent: "space-between",
//                 px: { xs: 2, sm: 3 }, py: 1.75,
//                 background: FB, color: "#fff",
//                 borderBottom: `1.5px solid ${FB_DARK}`,
//             }}>
//                 <Box>
//                     <Typography sx={{ fontSize: 15, fontWeight: 500, color: "#fff" }}>
//                         {selectedType}
//                         {isMultiSeries && seriesName && (
//                             <Box component="span" sx={{ ml: 1, fontSize: 12, color: "rgba(255,255,255,0.75)" }}>
//                                 — {seriesName}
//                             </Box>
//                         )}
//                     </Typography>
//                     <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.7)" }}>
//                         Format {selectedFormat}
//                     </Typography>
//                 </Box>
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//                     <Tooltip title="Zoom out">
//                         <IconButton size="small" sx={{ color: "#fff" }} onClick={handleZoomOut}>
//                             <ZoomOut sx={{ fontSize: 18 }} />
//                         </IconButton>
//                     </Tooltip>
//                     <Box sx={{
//                         px: "8px", py: "3px", bgcolor: "rgba(255,255,255,0.15)",
//                         borderRadius: "6px", mx: 0.5,
//                     }}>
//                         <Typography sx={{ fontSize: 12, fontWeight: 500, color: "#fff", minWidth: 40, textAlign: "center" }}>
//                             {Math.round(scale * 100)}%
//                         </Typography>
//                     </Box>
//                     <Tooltip title="Zoom in">
//                         <IconButton size="small" sx={{ color: "#fff" }} onClick={handleZoomIn}>
//                             <ZoomIn sx={{ fontSize: 18 }} />
//                         </IconButton>
//                     </Tooltip>
//                     <Tooltip title="Reset">
//                         <IconButton size="small" sx={{ color: "#fff" }} onClick={handleReset}>
//                             <OpenInFull sx={{ fontSize: 16 }} />
//                         </IconButton>
//                     </Tooltip>
//                     <IconButton size="small" sx={{ color: "#fff", ml: 0.5 }} onClick={onClose}>
//                         <Close sx={{ fontSize: 18 }} />
//                     </IconButton>
//                 </Box>
//             </Box>

//             {/* ── Image / drag area ── */}
//             <DialogContent
//                 ref={containerRef}
//                 sx={{
//                     p: 0,
//                     bgcolor: BG,
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     minHeight: isMobile ? "calc(100vh - 140px)" : 400,
//                     overflow: "hidden",
//                     cursor: isDragging ? "grabbing" : scale > 1 ? "grab" : "zoom-in",
//                     position: "relative",
//                     userSelect: "none",
//                 }}
//                 onMouseMove={handleMouseMove}
//                 onMouseDown={handleMouseDown}
//                 onMouseUp={handleMouseUp}
//                 onMouseLeave={handleMouseLeave}
//                 onTouchStart={handleTouchStart}
//                 onTouchEnd={handleTouchEnd}
//             >
//                 <Box
//                     sx={{
//                         // No transition while dragging for instant response
//                         transition: isDragging ? "none" : "transform 0.12s ease",
//                         transform: `translate(${translate.x}px, ${translate.y}px) scale(${scale})`,
//                         transformOrigin: `${origin.x}% ${origin.y}%`,
//                         display: "inline-block",
//                         lineHeight: 0,
//                         // Prevent the inner box from catching pointer events
//                         pointerEvents: "none",
//                     }}
//                 >
//                     <img
//                         src={large}
//                         alt="Preview"
//                         draggable={false}
//                         onError={(e) => { e.currentTarget.src = dummyImg; }}
//                         style={{
//                             maxWidth: "100%",
//                             maxHeight: isMobile ? "70vh" : "60vh",
//                             objectFit: "contain",
//                             display: "block",
//                             userSelect: "none",
//                             pointerEvents: "none",
//                         }}
//                     />
//                 </Box>
//             </DialogContent>

//             {/* ── Footer ── */}
//             <Box sx={{
//                 px: { xs: 2, sm: 3 }, py: 2,
//                 display: "flex", gap: 1.5, justifyContent: "flex-end",
//                 borderTop: `0.5px solid ${BORDER}`, bgcolor: "#fff",
//                 flexWrap: "wrap",
//             }}>
//                 <Button onClick={onClose} sx={btnGhostSx}>Cancel</Button>
//                 <Button
//                     onClick={onApply}
//                     disabled={isAlreadyApplied}
//                     startIcon={isAlreadyApplied
//                         ? <CheckCircle sx={{ fontSize: 16 }} />
//                         : <AutoAwesome sx={{ fontSize: 16 }} />}
//                     sx={{
//                         ...btnPrimarySx,
//                         ...(isAlreadyApplied && {
//                             bgcolor: GREEN_LT, color: GREEN,
//                             border: `0.5px solid ${GREEN}44`,
//                             "&:disabled": { bgcolor: GREEN_LT, color: GREEN }
//                         }),
//                     }}
//                 >
//                     {isAlreadyApplied ? "Currently active" : "Apply template"}
//                 </Button>
//             </Box>
//         </Dialog>
//     );
// }

// // ─── MAIN ─────────────────────────────────────────────────────────────────────
// export default function FormatSelectionScreen({ loggedInUser, companyData, connectionString }) {
//     const API = connectionString;
//     const auth = useAuth();
//     const { selectedCompany } = useAuth();
//     const authSelectedCompany = auth?.selectedCompany ?? null;
//     const muiTheme = useTheme();
//     const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
//     const isTablet = useMediaQuery(muiTheme.breakpoints.down('md'));

//     const [selectedType, setSelectedType] = useState('');
//     const [selectedFormat, setSelectedFormat] = useState(null);
//     const [appliedFormat, setAppliedFormat] = useState(null);
//     const [previewOpen, setPreviewOpen] = useState(false);
//     const [snack, setSnack] = useState({ open: false, msg: '', severity: 'success' });

//     // ✅ NEW: State to track current format count
//     const [currentFormatCount, setCurrentFormatCount] = useState(FORMAT_COUNT);

//     // Multi-series states
//     const [seriesList, setSeriesList] = useState([]);
//     const [selectedSeries, setSelectedSeries] = useState(null);
//     const [seriesFormats, setSeriesFormats] = useState({});
//     const [loadingSeries, setLoadingSeries] = useState(false);

//     const AppRegID = selectedCompany?.AppRegID || null;
//     const isMultiSeriesType = MULTI_SERIES_TYPES.includes(selectedType);

//     // ── Company resolution ────────────────────────────────────────────────────
//     const companyFromProp = Array.isArray(companyData) ? companyData[0] : (companyData || null);
//     let fallbackLS = null;
//     try {
//         const s = typeof window !== 'undefined' ? window.localStorage.getItem('selectedCompany') : null;
//         if (s) fallbackLS = JSON.parse(s);
//     } catch { fallbackLS = null; }

//     const companyObj = authSelectedCompany || companyFromProp
//         || (loggedInUser && (loggedInUser.selectedCompany || loggedInUser.company || loggedInUser.companyData))
//         || fallbackLS || {};

//     const tryNum = (v) => { if (v == null || v === '') return 0; const n = Number(v); return isFinite(n) ? n : 0; };
//     const GCompId_RAW = companyObj?.GCompId ?? companyObj?.GCompid ?? companyObj?.GCompID ?? null;
//     const GCompId = (GCompId_RAW == null || GCompId_RAW === '') ? null : tryNum(GCompId_RAW);

//     let CompId = 0;
//     for (const c of [companyObj?.CompId, companyObj?.CompID, companyObj?.Compid, companyObj?.CompanyId, loggedInUser?.CompId, loggedInUser?.CompanyId]) {
//         const n = tryNum(c);
//         if (n > 0) { CompId = n; break; }
//     }
//     if (!CompId && fallbackLS) {
//         for (const c of [fallbackLS?.CompId, fallbackLS?.CompID, fallbackLS?.CompanyId]) {
//             const n = tryNum(c);
//             if (n > 0) { CompId = n; break; }
//         }
//     }

//     const CURRENT_USER_ID = Number(loggedInUser?.UserId ?? loggedInUser?.UserID ?? 0);
//     const toMySqlDT = (d) => {
//         const p = (n) => String(n).padStart(2, '0');
//         return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
//     };

//     const getBookNameKey = (type, series = null) => {
//         const base = type.replace(/\s+/g, '');
//         if (series) {
//             const seriesId = series?.SeriesId || series?.SeriesID || series?.seriesId || series?.Id || series?.id || 0;
//             return `${base}_Series_${seriesId}`;
//         }
//         return base;
//     };

//     const getSeriesId = (series) => {
//         return series?.SeriesId || series?.SeriesID || series?.seriesId || series?.Id || series?.id || 0;
//     };

//     // ── Fetch series ──────────────────────────────────────────────────────────
//     const fetchSeriesForType = async (type) => {
//         setLoadingSeries(true);
//         setSeriesList([]);
//         setSelectedSeries(null);
//         setSeriesFormats({});
//         try {
//             const companyIdParam = CompId || 0;
//             const typeNorm = type.replace(/\s+/g, '');
//             const resp = await axios.get(`${API}/api/seriesForPDF`, {
//                 params: { companyId: companyIdParam, documentType: typeNorm },
//                 timeout: 15000,
//             });

//             let arr = [];
//             if (resp?.data) {
//                 if (Array.isArray(resp.data.series)) arr = resp.data.series;
//                 else if (Array.isArray(resp.data)) arr = resp.data;
//                 else if (Array.isArray(resp.data.data)) arr = resp.data.data;
//             }
//             setSeriesList(arr);

//             if (arr.length > 0) {
//                 try {
//                     const fmtResp = await axios.get(`${API}/api/companies`, {
//                         params: { companyId: companyIdParam },
//                         timeout: 15000,
//                     });
//                     let companies = [];
//                     if (fmtResp?.data) {
//                         if (Array.isArray(fmtResp.data.companies)) companies = fmtResp.data.companies;
//                         else if (Array.isArray(fmtResp.data)) companies = fmtResp.data;
//                         else if (Array.isArray(fmtResp.data.data)) companies = fmtResp.data.data;
//                     }
//                     const wantedId = Number(CompId || companyIdParam || 0);
//                     const rec = companies.find(c => tryNum(c?.CompId ?? c?.CompID ?? 0) === wantedId) || companies[0];
//                     if (rec && Array.isArray(rec.formats)) {
//                         const norm = (s) => String(s || '').replace(/\s+/g, '').toLowerCase();
//                         const fmtMap = {};
//                         for (const series of arr) {
//                             const sId = getSeriesId(series);
//                             const wantedBookName = norm(typeNorm);
//                             for (const f of rec.formats) {
//                                 const bName = norm(f?.BookName ?? '');
//                                 const bId = Number(f?.BookID ?? f?.BookId ?? 0);
//                                 const fSeriesId = Number(f?.SeriesId ?? f?.seriesId ?? 0);
//                                 if (bId && bName === wantedBookName && fSeriesId === Number(sId)) {
//                                     fmtMap[sId] = bId;
//                                     break;
//                                 }
//                             }
//                             if (!fmtMap[sId]) {
//                                 for (const f of rec.formats) {
//                                     const bName = norm(f?.BookName ?? '');
//                                     const bId = Number(f?.BookID ?? f?.BookId ?? 0);
//                                     const fSeriesId = Number(f?.SeriesId ?? f?.seriesId ?? 0);
//                                     if (bId && bName === wantedBookName && (!fSeriesId || fSeriesId === 0)) {
//                                         fmtMap[sId] = bId;
//                                         break;
//                                     }
//                                 }
//                             }
//                         }
//                         setSeriesFormats(fmtMap);
//                     }
//                 } catch (err) {
//                     console.warn('Error fetching series formats', err?.message);
//                 }
//             }
//         } catch (err) {
//             console.warn('Series API error', err?.response?.data || err?.message);
//             setSeriesList([]);
//             setSelectedSeries(null);
//             setSeriesFormats({});
//             setSnack({ open: true, msg: err?.response?.data?.message || 'Failed to load series.', severity: 'error' });
//         } finally {
//             setLoadingSeries(false);
//         }
//     };

//     // ── Handlers ─────────────────────────────────────────────────────────────
//     const handleSelectType = async (type) => {
//         // ✅ NEW: Update format count based on selected type
//         const formatCount = getFormatCount(type);
//         setCurrentFormatCount(formatCount);

//         setSelectedType(type);
//         setSelectedFormat(null);
//         setAppliedFormat(null);
//         setSelectedSeries(null);
//         setSeriesList([]);
//         setSeriesFormats({});

//         if (MULTI_SERIES_TYPES.includes(type)) {
//             await fetchSeriesForType(type);
//         } else {
//             try {
//                 const companyIdParam = CompId || 0;
//                 const resp = await axios.get(`${API}/api/companies`, { params: { companyId: companyIdParam }, timeout: 15000 });
//                 let arr = [];
//                 if (resp?.data) {
//                     if (Array.isArray(resp.data.companies)) arr = resp.data.companies;
//                     else if (Array.isArray(resp.data)) arr = resp.data;
//                     else if (Array.isArray(resp.data.data)) arr = resp.data.data;
//                 }
//                 const wantedId = Number(CompId || companyIdParam || 0);
//                 const rec = arr.find(c => tryNum(c?.CompId ?? c?.CompID ?? 0) === wantedId) || arr[0];
//                 if (rec && Array.isArray(rec.formats)) {
//                     const norm = (s) => String(s || '').replace(/\s+/g, '').toLowerCase();
//                     const wantedNorm = norm(type);
//                     let found = null;
//                     for (const f of rec.formats) {
//                         const bName = norm(f?.BookName ?? '');
//                         const bId = Number(f?.BookID ?? f?.BookId ?? 0);
//                         if (bId && bName === wantedNorm) { found = bId; break; }
//                     }
//                     setAppliedFormat(found ?? 1);
//                 } else {
//                     setAppliedFormat(1);
//                 }
//             } catch (err) {
//                 console.warn('companies API error', err?.message);
//             }
//         }
//     };

//     const handleSelectSeries = (series) => {
//         setSelectedSeries(series);
//         setSelectedFormat(null);
//         const sId = getSeriesId(series);
//         const fmt = seriesFormats[sId] || null;
//         setAppliedFormat(fmt);
//     };

//     const handleCardClick = (format) => {
//         setSelectedFormat(format);
//         setPreviewOpen(true);
//     };

//     const handleApplyTemplate = async () => {
//         if (!selectedType || !selectedFormat) {
//             setSnack({ open: true, msg: 'Select a document type and format first.', severity: 'warning' });
//             return;
//         }
//         if (isMultiSeriesType && !selectedSeries) {
//             setSnack({ open: true, msg: 'Please select a series first.', severity: 'warning' });
//             return;
//         }
//         if (!CompId) {
//             setSnack({ open: true, msg: 'Unable to determine your company. Please select a company first.', severity: 'error' });
//             return;
//         }
//         const now = new Date();
//         const bookName = selectedType.replace(/\s+/g, '');
//         const seriesId = isMultiSeriesType ? getSeriesId(selectedSeries) : null;

//         const payload = {
//             GCompId: null, CompId,
//             BookName: bookName,
//             BookID: Number(selectedFormat),
//             FormName: isMultiSeriesType
//                 ? `${selectedType}-Series-${seriesId}-Format-${selectedFormat}`
//                 : `${selectedType}-Format-${selectedFormat}`,
//             CompDefault: 0, PPO: 0,
//             paperheight: 842, paperwidth: 595,
//             TopMargin: 0, LeftMargin: 0, RightMargin: 0, BottomMargin: 0,
//             Heading: '',
//             AddUserId: CURRENT_USER_ID, AddUserDateTime: toMySqlDT(now),
//             EditUserId: CURRENT_USER_ID, EditUserDateTime: toMySqlDT(now),
//             AppRegID,
//             ...(isMultiSeriesType && seriesId ? { SeriesId: seriesId } : {}),
//         };
//         try {
//             const res = await axios.post(`${API}/api/printmaster`, payload, { headers: { 'Content-Type': 'application/json' }, timeout: 15000 });
//             const ok = res?.data?.success === true || res?.data?.insertId || (res?.data?.affectedRows > 0);
//             if (ok) {
//                 const newFormat = Number(selectedFormat);
//                 setAppliedFormat(newFormat);
//                 if (isMultiSeriesType && selectedSeries) {
//                     const sId = getSeriesId(selectedSeries);
//                     setSeriesFormats(prev => ({ ...prev, [sId]: newFormat }));
//                 }
//                 setPreviewOpen(false);
//                 setSelectedFormat(null);
//                 const seriesLabel = isMultiSeriesType && selectedSeries
//                     ? ` for ${selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || 'series'}`
//                     : '';
//                 setSnack({ open: true, msg: `Format ${selectedFormat} applied successfully${seriesLabel}!`, severity: 'success' });
//             } else {
//                 setSnack({ open: true, msg: res?.data?.message || 'Failed to apply template.', severity: 'error' });
//             }
//         } catch (err) {
//             const msg = err.response?.data?.message || `Server error ${err.response?.status || ''}` || 'Network error.';
//             setSnack({ open: true, msg, severity: 'error' });
//         }
//     };

//     const showFormatGrid = selectedType && (!isMultiSeriesType || (isMultiSeriesType && selectedSeries));

//     const getActiveFormatLabel = () => {
//         if (isMultiSeriesType && selectedSeries) {
//             const sId = getSeriesId(selectedSeries);
//             const fmt = seriesFormats[sId];
//             if (fmt) {
//                 const sName = selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || `Series ${sId}`;
//                 return `Format ${fmt} — ${sName}`;
//             }
//             return null;
//         }
//         if (appliedFormat && selectedType && !isMultiSeriesType) return `Format ${appliedFormat} active`;
//         return null;
//     };

//     const activeLabel = getActiveFormatLabel();

//     // ─── RENDER ───────────────────────────────────────────────────────────────
//     return (
//         <Box sx={{ minHeight: "100vh", background: BG }}>

//             {/* ── TOPBAR ── */}
//             <Box sx={{
//                 background: "#fff", borderBottom: `0.5px solid ${BORDER}`,
//                 px: { xs: 2, sm: 3, md: 4 }, py: 1.5,
//                 display: "flex", alignItems: "center", justifyContent: "space-between",
//             }}>
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
//                     <Box sx={{
//                         width: 36, height: 36, background: FB, borderRadius: "9px",
//                         display: "flex", alignItems: "center", justifyContent: "center"
//                     }}>
//                         <FilePresent sx={{ color: "#fff", fontSize: 19 }} />
//                     </Box>
//                     <Box>
//                         <Typography sx={{ fontSize: 16, fontWeight: 500, color: T1, lineHeight: 1.2 }}>
//                             Printing <Box component="span" sx={{ color: FB }}>utilities</Box>
//                         </Typography>
//                         <Typography sx={{ fontSize: 11, color: T2 }}>
//                             Document template manager
//                         </Typography>
//                     </Box>
//                 </Box>
//                 {activeLabel && (
//                     <Box sx={{
//                         display: "flex", alignItems: "center", gap: "6px",
//                         px: "10px", py: "4px", bgcolor: GREEN_LT, borderRadius: "20px",
//                         border: `0.5px solid ${GREEN}44`,
//                     }}>
//                         <CheckCircle sx={{ fontSize: 13, color: GREEN }} />
//                         <Typography sx={{ fontSize: 12, fontWeight: 500, color: GREEN }}>
//                             {activeLabel}
//                         </Typography>
//                     </Box>
//                 )}
//             </Box>

//             {/* ── CONTENT ── */}
//             <Box sx={{ maxWidth: 1200, mx: "auto", px: { xs: 1.5, sm: 3, md: 4 }, py: { xs: 2, sm: 3, md: 4 } }}>

//                 {/* ── Step 1 — Type selector ── */}
//                 <Box sx={{ ...cardBaseSx, p: { xs: 1.5, sm: 2 }, mb: { xs: 1.5, sm: 2 } }}>
//                     <Typography sx={{
//                         fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".4px", mb: 1,
//                         display: "flex", alignItems: "center", gap: "6px"
//                     }}>
//                         <Box component="span" sx={{ width: 14, height: 14, bgcolor: FB, borderRadius: "4px", display: "inline-block" }} />
//                         Step 1 — Select document type
//                     </Typography>

//                     <FormControl fullWidth size="small">
//                         <Select value={selectedType} onChange={(e) => handleSelectType(e.target.value)}
//                             displayEmpty IconComponent={KeyboardArrowDown}
//                             renderValue={(val) => val || (
//                                 <Typography sx={{ fontSize: 13, color: T2 }}>Select a document type…</Typography>
//                             )}
//                             sx={{
//                                 bgcolor: BG, borderRadius: "8px", fontSize: 13,
//                                 "& .MuiOutlinedInput-notchedOutline": { borderColor: BORDER },
//                                 "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: FB_MID },
//                                 "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: FB, borderWidth: 2 },
//                                 "& .MuiSelect-select": { py: 1.25, px: 1.5, fontSize: 13, fontWeight: 500, color: T1 },
//                             }}
//                             MenuProps={{
//                                 PaperProps: {
//                                     sx: {
//                                         borderRadius: "10px", mt: 0.5,
//                                         border: `0.5px solid ${BORDER}`,
//                                         boxShadow: "0 8px 24px rgba(24,119,242,0.10)",
//                                     }
//                                 }
//                             }}
//                         >
//                             {documentTypes.map((type) => (
//                                 <MenuItem key={type} value={type}
//                                     sx={{
//                                         fontSize: 13, fontWeight: 500, color: T1, py: 1.25, px: 2, gap: 1.5,
//                                         "&:hover": { bgcolor: FB_LIGHT },
//                                         "&.Mui-selected": { bgcolor: FB_LIGHT, color: FB },
//                                         "&.Mui-selected:hover": { bgcolor: FB_LIGHT },
//                                     }}
//                                 >
//                                     <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: FB, flexShrink: 0 }} />
//                                     {type}
//                                     {MULTI_SERIES_TYPES.includes(type) && (
//                                         <Chip
//                                             label="Multi-series"
//                                             size="small"
//                                             sx={{
//                                                 ml: "auto", fontSize: 10, height: 20,
//                                                 bgcolor: FB_LIGHT, color: FB,
//                                                 border: `0.5px solid ${FB_MID}`,
//                                             }}
//                                         />
//                                     )}
//                                 </MenuItem>
//                             ))}
//                         </Select>
//                     </FormControl>
//                 </Box>

//                 {/* ── Step 1.5 — Series selector ── */}
//                 {isMultiSeriesType && selectedType && (
//                     <Fade in={isMultiSeriesType}>
//                         <Box sx={{ ...cardBaseSx, p: { xs: 1.5, sm: 2 }, mb: { xs: 1.5, sm: 2 } }}>
//                             <Typography sx={{
//                                 fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".4px", mb: 1,
//                                 display: "flex", alignItems: "center", gap: "6px"
//                             }}>
//                                 <Box component="span" sx={{ width: 14, height: 14, bgcolor: FB, borderRadius: "4px", display: "inline-block" }} />
//                                 Step 2 — Select series
//                                 <Chip
//                                     label="Multi-series document"
//                                     size="small"
//                                     sx={{
//                                         ml: 1, fontSize: 10, height: 20,
//                                         bgcolor: FB_LIGHT, color: FB,
//                                         border: `0.5px solid ${FB_MID}`,
//                                     }}
//                                 />
//                             </Typography>
//                             <Typography sx={{ fontSize: 13, color: T2, mb: 1.5 }}>
//                                 This document type supports multiple series. Select a series to set its format individually.
//                             </Typography>

//                             {loadingSeries ? (
//                                 <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", py: 4, gap: 1.5 }}>
//                                     <CircularProgress size={24} sx={{ color: FB }} />
//                                     <Typography sx={{ fontSize: 13, color: T2 }}>Loading series…</Typography>
//                                 </Box>
//                             ) : seriesList.length > 0 ? (
//                                 <Grid container spacing={{ xs: 1, sm: 1.5 }}>
//                                     {seriesList.map((series, index) => {
//                                         const sId = getSeriesId(series);
//                                         const isSelected = selectedSeries && getSeriesId(selectedSeries) === sId;
//                                         const sAppliedFormat = seriesFormats[sId] || null;
//                                         return (
//                                             <Grid item key={sId} xs={12} sm={6} md={4}>
//                                                 <SeriesCard
//                                                     series={series}
//                                                     isSelected={isSelected}
//                                                     appliedFormat={sAppliedFormat}
//                                                     onClick={handleSelectSeries}
//                                                     index={index}
//                                                 />
//                                             </Grid>
//                                         );
//                                     })}
//                                 </Grid>
//                             ) : (
//                                 <Box sx={{
//                                     py: 4, textAlign: "center",
//                                     border: `1.5px dashed ${BORDER}`, borderRadius: "10px",
//                                 }}>
//                                     <Box sx={{
//                                         width: 44, height: 44, bgcolor: FB_LIGHT, borderRadius: "11px",
//                                         display: "flex", alignItems: "center", justifyContent: "center",
//                                         mx: "auto", mb: 1,
//                                     }}>
//                                         <BarChart sx={{ fontSize: 22, color: FB_MID }} />
//                                     </Box>
//                                     <Typography sx={{ fontSize: 14, fontWeight: 500, color: T1, mb: "4px" }}>
//                                         No series found
//                                     </Typography>
//                                     <Typography sx={{ fontSize: 12, color: T2 }}>
//                                         No series available for {selectedType}. Please create a series first.
//                                     </Typography>
//                                 </Box>
//                             )}

//                             {seriesList.length > 0 && Object.keys(seriesFormats).length > 0 && (
//                                 <Box sx={{
//                                     mt: 2, p: 1.5, bgcolor: BG, borderRadius: "8px",
//                                     border: `0.5px solid ${BORDER}`,
//                                 }}>
//                                     <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: 1, letterSpacing: ".3px" }}>
//                                         FORMAT SUMMARY
//                                     </Typography>
//                                     <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                                         {seriesList.map((series) => {
//                                             const sId = getSeriesId(series);
//                                             const sName = series?.SeriesName || series?.seriesName || series?.Name || series?.name || `Series ${sId}`;
//                                             const fmt = seriesFormats[sId];
//                                             return (
//                                                 <Chip
//                                                     key={sId}
//                                                     icon={fmt ? <CheckCircle sx={{ fontSize: 12, color: `${GREEN} !important` }} /> : undefined}
//                                                     label={`${sName}: ${fmt ? `Format ${fmt}` : 'Not set'}`}
//                                                     size="small"
//                                                     sx={{
//                                                         fontSize: 11, height: 24,
//                                                         bgcolor: fmt ? GREEN_LT : "#fff",
//                                                         color: fmt ? GREEN : T2,
//                                                         border: `0.5px solid ${fmt ? GREEN + '44' : BORDER}`,
//                                                         "& .MuiChip-icon": { ml: "6px" },
//                                                     }}
//                                                 />
//                                             );
//                                         })}
//                                     </Box>
//                                 </Box>
//                             )}
//                         </Box>
//                     </Fade>
//                 )}

//                 {/* ── Step 2/3 — Format grid ── */}
//                 {showFormatGrid ? (
//                     <Fade in={showFormatGrid}>
//                         <Box>
//                             <Box sx={{
//                                 ...cardBaseSx, px: { xs: 1.5, sm: 2 }, py: 1.5,
//                                 mb: { xs: 1.5, sm: 2 },
//                                 display: "flex", alignItems: "center", justifyContent: "space-between",
//                                 flexWrap: "wrap", gap: 1
//                             }}>
//                                 <Box>
//                                     <Typography sx={{
//                                         fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".4px", mb: "2px",
//                                         display: "flex", alignItems: "center", gap: "6px"
//                                     }}>
//                                         <Box component="span" sx={{ width: 14, height: 14, bgcolor: FB, borderRadius: "4px", display: "inline-block" }} />
//                                         Step {isMultiSeriesType ? '3' : '2'} — Choose format
//                                     </Typography>
//                                     <Typography sx={{ fontSize: 15, fontWeight: 500, color: T1 }}>
//                                         {selectedType} templates
//                                         {isMultiSeriesType && selectedSeries && (
//                                             <Box component="span" sx={{
//                                                 ml: 1, fontSize: 12, color: FB, fontWeight: 500,
//                                                 px: "8px", py: "2px", bgcolor: FB_LIGHT, borderRadius: "12px",
//                                                 border: `0.5px solid ${FB_MID}`,
//                                             }}>
//                                                 {selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || selectedSeries?.name || 'Selected Series'}
//                                             </Box>
//                                         )}
//                                         <Box component="span" sx={{ ml: 1, fontSize: 12, color: T2, fontWeight: 400 }}>
//                                             ({currentFormatCount} available)
//                                         </Box>
//                                     </Typography>
//                                 </Box>
//                                 {appliedFormat && (
//                                     <Box sx={{
//                                         display: "inline-flex", alignItems: "center", gap: "6px",
//                                         px: "10px", py: "4px", bgcolor: GREEN_LT, borderRadius: "20px",
//                                         border: `0.5px solid ${GREEN}44`
//                                     }}>
//                                         <CheckCircle sx={{ fontSize: 13, color: GREEN }} />
//                                         <Typography sx={{ fontSize: 12, fontWeight: 500, color: GREEN }}>
//                                             Format {appliedFormat} is active
//                                             {isMultiSeriesType && selectedSeries && (
//                                                 <Box component="span" sx={{ ml: 0.5, fontSize: 11, color: GREEN, opacity: 0.8 }}>
//                                                     for this series
//                                                 </Box>
//                                             )}
//                                         </Typography>
//                                     </Box>
//                                 )}
//                             </Box>

//                             <Grid container spacing={{ xs: 1.25, sm: 2 }}>
//                                 {Array.from({ length: currentFormatCount }, (_, i) => i + 1).map((format) => (
//                                     <Grid item key={format} xs={6} sm={4} md={3}>
//                                         <FormatCard
//                                             format={format}
//                                             selectedType={selectedType}
//                                             isApplied={appliedFormat === format}
//                                             onClick={() => handleCardClick(format)}
//                                         />
//                                     </Grid>
//                                 ))}
//                             </Grid>
//                         </Box>
//                     </Fade>
//                 ) : !selectedType ? (
//                     <Box sx={{
//                         ...cardBaseSx, py: { xs: 6, sm: 8 }, textAlign: "center",
//                         border: `1.5px dashed ${BORDER}`,
//                     }}>
//                         <Box sx={{
//                             width: 52, height: 52, bgcolor: FB_LIGHT, borderRadius: "13px",
//                             display: "flex", alignItems: "center", justifyContent: "center",
//                             mx: "auto", mb: 1.5,
//                         }}>
//                             <FilePresent sx={{ fontSize: 26, color: FB_MID }} />
//                         </Box>
//                         <Typography sx={{ fontSize: 15, fontWeight: 500, color: T1, mb: "4px" }}>
//                             No document type selected
//                         </Typography>
//                         <Typography sx={{ fontSize: 13, color: T2 }}>
//                             Select a type above to browse professional templates
//                         </Typography>
//                     </Box>
//                 ) : isMultiSeriesType && !selectedSeries ? (
//                     !loadingSeries && seriesList.length > 0 && (
//                         <Box sx={{
//                             ...cardBaseSx, py: { xs: 5, sm: 6 }, textAlign: "center",
//                             border: `1.5px dashed ${BORDER}`,
//                         }}>
//                             <Box sx={{
//                                 width: 52, height: 52, bgcolor: FB_LIGHT, borderRadius: "13px",
//                                 display: "flex", alignItems: "center", justifyContent: "center",
//                                 mx: "auto", mb: 1.5,
//                             }}>
//                                 <BarChart sx={{ fontSize: 26, color: FB_MID }} />
//                             </Box>
//                             <Typography sx={{ fontSize: 15, fontWeight: 500, color: T1, mb: "4px" }}>
//                                 Select a series to continue
//                             </Typography>
//                             <Typography sx={{ fontSize: 13, color: T2 }}>
//                                 Choose a series from above to set its template format
//                             </Typography>
//                         </Box>
//                     )
//                 ) : null}
//             </Box>

//             {/* ── Preview dialog ── */}
//             <PreviewDialog
//                 open={previewOpen}
//                 onClose={() => { setPreviewOpen(false); setSelectedFormat(null); }}
//                 selectedType={selectedType}
//                 selectedFormat={selectedFormat}
//                 appliedFormat={appliedFormat}
//                 onApply={handleApplyTemplate}
//                 selectedSeries={selectedSeries}
//             />

//             {/* ── Snackbar ── */}
//             <Snackbar open={snack.open} autoHideDuration={3000}
//                 onClose={() => setSnack(s => ({ ...s, open: false }))}
//                 anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//             >
//                 <Alert severity={snack.severity} variant="filled"
//                     onClose={() => setSnack(s => ({ ...s, open: false }))}
//                     sx={{ borderRadius: "8px", fontWeight: 500 }}
//                 >
//                     {snack.msg}
//                 </Alert>
//             </Snackbar>
//         </Box>
//     );
// }















import React, { useRef, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import {
    Box, Typography, Grid, Card, CardMedia, CardContent, Chip,
    Dialog, DialogContent, Button, IconButton, Snackbar, Alert,
    Fade, Zoom, Skeleton, Tooltip, useTheme, useMediaQuery,
    CircularProgress, Checkbox, FormControlLabel, Popover,
} from '@mui/material';
import {
    CheckCircle, Close, ZoomIn, ZoomOut, OpenInFull, FilePresent,
    AutoAwesome, BarChart, ArrowForwardIos, PaletteOutlined,
    RequestQuoteOutlined, AssignmentOutlined, DescriptionOutlined,
    LocalShippingOutlined, ReceiptLongOutlined, ReceiptOutlined,
    UndoOutlined, PostAddOutlined, ShoppingCartOutlined, InventoryOutlined,
} from '@mui/icons-material';

// ─── DESIGN TOKENS ────────────────────────────────────────────────────────────
// Premium SaaS palette — refined neutrals, soft layered shadows, one confident accent.
const FB = "#1565c0";
const FB_DARK = "#0d47a1";
const FB_LIGHT = "#eaf2fd";
const FB_MID = "#90caf9";
const FB_SOFT = "rgba(21,101,192,0.08)";
const GRAD_BRAND = "linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)";
const GRAD_SHEEN = "linear-gradient(135deg, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0) 60%)";
const BG = "#f4f6fb";
const SURFACE = "#ffffff";
const SURFACE_ALT = "#fafbfd";
const BORDER = "#e3e8f0";
const BORDER_SOFT = "#edf0f6";
const T1 = "#101828";
const T2 = "#64748b";
const T3 = "#94a3b8";
const GREEN = "#12805c";
const GREEN_LT = "#e6f6f0";
const GREEN_BORDER = "#a8e0c9";
const RED = "#c62828";

// Soft, layered elevation scale — replaces flat 1px-border cards.
const SHADOW_XS = "0 1px 2px rgba(16,24,40,0.04)";
const SHADOW_SM = "0 2px 8px rgba(16,24,40,0.06), 0 1px 2px rgba(16,24,40,0.04)";
const SHADOW_MD = "0 8px 24px rgba(16,24,40,0.08), 0 2px 6px rgba(16,24,40,0.04)";
const SHADOW_LG = "0 20px 48px rgba(16,24,40,0.14), 0 6px 16px rgba(16,24,40,0.06)";
const SHADOW_BRAND = "0 10px 28px rgba(21,101,192,0.16), 0 2px 8px rgba(21,101,192,0.10)";
const EASE = "cubic-bezier(0.16, 1, 0.3, 1)";

// ─── CONSTANTS ────────────────────────────────────────────────────────────────
const publicUrl = typeof process !== 'undefined' && process.env?.PUBLIC_URL ? process.env.PUBLIC_URL : '';
const dummyImg = `${publicUrl}/Quotation_Image.jpeg`;

// ✅ ALL document types now show A4 badge (display-only for formats 1-10)
// Sale Challan and Purchase Dispatch additionally get real A4/A5 variants for formats 11/12/13
const PAGE_SIZE_DOCUMENT_TYPES = [
    'Quotation',
    // 'Sale Order',
    'Proforma Invoice',
    'Sale Challan',
    'Sale Invoice',
    // 'Purchase Order',
    'Purchase Dispatch',
    'Purchase Invoice',
    'Credit Note',
    'Debit Note',
];

// ✅ Only formats 11/12/13 get real A4/A5 split variants (Sale Challan & Purchase Dispatch only)
const PAGE_SIZE_VARIANT_DOCUMENT_TYPES = ['Sale Challan', 'Purchase Dispatch'];
const PAGE_SIZE_CONFIGURABLE_FORMATS = [11, 12, 13];

// ✅ Format configuration for different document types
const FORMAT_CONFIG = {
    'Quotation': 10,
    'Proforma Invoice': 10,
    'Sale Challan': 13,
    'Sale Invoice': 23,
    'Purchase Order': 10,
    'Purchase Dispatch': 13,
    'Purchase Invoice': 10,
    'Credit Note': 17,
    'Debit Note': 10,
};

// ✅ Exclude specific formats from document types
const FORMAT_EXCLUSIONS = {
    'Sale Invoice': [11, 12, 13, 19, 20, 21, 22],
    'Credit Note': [11, 12, 13, 14, 15],
};

// ✅ Get format count for any document type
const getFormatCount = (type) => {
    return FORMAT_CONFIG[type] || 10;
};

// ✅ Build expanded format list with separate A4/A5 variants for configurable formats
// Each item: { format, pageSize, badgePageSize }
// - pageSize: actual page size value used for logic (null for non-variant, 'A4'/'A5' for variant)
// - badgePageSize: what badge to DISPLAY on the card (may be 'A4' for display-only on formats 1-10)
const buildFormatList = (type, count) => {
    const list = [];
    const excludedFormats = FORMAT_EXCLUSIONS[type] || [];
    for (let i = 1; i <= count; i++) {
        if (excludedFormats.includes(i)) continue;
        if (PAGE_SIZE_VARIANT_DOCUMENT_TYPES.includes(type) && PAGE_SIZE_CONFIGURABLE_FORMATS.includes(i)) {
            // ✅ Formats 11/12/13 for Sale Challan & Purchase Dispatch: split into real A4 and A5 variants
            list.push({ format: i, pageSize: 'A4', badgePageSize: 'A4' });
            list.push({ format: i, pageSize: 'A5', badgePageSize: 'A5' });
        } else if (PAGE_SIZE_DOCUMENT_TYPES.includes(type)) {
            // ✅ Formats 1-10, 14-15 for ALL PAGE_SIZE_DOCUMENT_TYPES: show A4 badge for display only
            // pageSize remains null so existing isVariantApplied logic is NOT affected
            list.push({ format: i, pageSize: null, badgePageSize: 'A4' });
        } else {
            // ✅ Any document types not in PAGE_SIZE_DOCUMENT_TYPES: no badge
            list.push({ format: i, pageSize: null, badgePageSize: null });
        }
    }
    return list;
};

const getImageForTypeFormat = (type = '', format = 0, pageSize = null) => {
    const idx = Number(format) || 0;
    if (!idx || idx < 1 || idx > 25) return { thumb: dummyImg, large: dummyImg };
    const norm = (type || '').replace(/\s+/g, '').toLowerCase();
    const suffix = pageSize === 'A5' ? `${idx}A5` : idx;
    const build = (base) => `${publicUrl}/${base}${suffix}.jpg`;
    const map = {
        quotation: () => build('Quotation'),
        saleorder: () => build('SaleOrder'),
        proformainvoice: () => build('ProformaInvoice'),
        salechallan: () => build('SaleChallan'),
        saleinvoice: () => build('SaleInvoice'),
        creditnote: () => build('CreditNote'),
        purchaseorder: () => build('PurchaseOrder'),
        purchasedispatch: () => build('PurchaseChallan'),
        purchaseinvoice: () => build('PurchaseInvoice'),
        debitnote: () => build('DebitNote'),
    };
    const src = map[norm] ? map[norm]() : dummyImg;
    return { thumb: src, large: src };
};

const documentTypes = [
    'Quotation',
    'Sale Order',
    'Proforma Invoice',
    'Sale Challan',
    'Sale Invoice',
    'Credit Note',
    'Purchase Order',
    'Purchase Dispatch',
    'Purchase Invoice',
    'Debit Note',
];

// Document types that support multiple series
const MULTI_SERIES_TYPES = ['Sale Challan', 'Sale Invoice', 'Proforma Invoice', 'Credit Note'];

// Plan-based visibility: "Billing" plan only shows these 4; "Accounting" (or any
// other/unknown plan) shows every type in documentTypes, unchanged.
const BILLING_PLAN_DOC_TYPES = ['Quotation', 'Sale Challan', 'Sale Invoice', 'Credit Note'];

// ─── Per-document-type icon lookup (additive, decorative only — does not touch documentTypes values) ──
const DOC_TYPE_ICONS = {
    'Quotation': RequestQuoteOutlined,
    'Sale Order': ShoppingCartOutlined,
    'Proforma Invoice': DescriptionOutlined,
    'Sale Challan': LocalShippingOutlined,
    'Sale Invoice': ReceiptOutlined,
    'Credit Note': UndoOutlined,
    'Purchase Order': AssignmentOutlined,
    'Purchase Dispatch': InventoryOutlined,
    'Purchase Invoice': ReceiptLongOutlined,
    'Debit Note': PostAddOutlined,
};
const getDocTypeIcon = (type) => DOC_TYPE_ICONS[type] || FilePresent;

const FORMAT_COUNT = 10;
const formats = Array.from({ length: FORMAT_COUNT }, (_, i) => i + 1);

// ─── SHARED SX ────────────────────────────────────────────────────────────────
const cardBaseSx = {
    background: SURFACE, border: `1px solid ${BORDER}`, borderRadius: '18px', overflow: 'hidden',
    boxShadow: SHADOW_SM, transition: `box-shadow 0.3s ${EASE}`,
};

const btnPrimarySx = {
    background: GRAD_BRAND, color: "#fff", borderRadius: '10px', fontSize: 13.5, fontWeight: 700,
    textTransform: "none", px: 2.75, height: 40, letterSpacing: '0.1px',
    boxShadow: SHADOW_BRAND, transition: `all 0.25s ${EASE}`,
    "&:hover": { background: GRAD_BRAND, boxShadow: '0 14px 32px rgba(21,101,192,0.24), 0 4px 10px rgba(21,101,192,0.14)', transform: 'translateY(-1px)' },
    "&:active": { transform: 'translateY(0)' },
    "&:disabled": { background: '#cfd8e3', color: "#fff", boxShadow: 'none' },
};

const btnGhostSx = {
    background: SURFACE, color: T2, border: `1px solid ${BORDER}`, borderRadius: '10px',
    fontSize: 13.5, fontWeight: 600, textTransform: "none", px: 2.75, height: 40,
    transition: `all 0.2s ${EASE}`,
    "&:hover": { background: SURFACE_ALT, color: T1, borderColor: '#cbd5e1' },
};

// ─── HELPER: check if page size toggle should show ────────────────────────────
const shouldShowPageSize = (docType, format) => {
    return (
        PAGE_SIZE_DOCUMENT_TYPES.includes(docType) &&
        PAGE_SIZE_CONFIGURABLE_FORMATS.includes(Number(format))
    );
};

// ─── SERIES CARD ──────────────────────────────────────────────────────────────
function SeriesCard({ series, isSelected, appliedFormat, onClick, index }) {
    const seriesName = series?.SeriesName || series?.seriesName || series?.Name || series?.name || `Series ${series?.SeriesId || series?.SeriesID || index + 1}`;
    const seriesId = series?.SeriesId || series?.SeriesID || series?.seriesId || series?.Id || series?.id || index + 1;

    return (
        <Zoom in style={{ transitionDelay: `${index * 35}ms` }}>
            <Card onClick={() => onClick(series)}
                sx={{
                    cursor: "pointer", borderRadius: '18px', overflow: "hidden", position: 'relative',
                    border: isSelected ? `2px solid ${FB}` : `1px solid ${BORDER}`,
                    boxShadow: isSelected
                        ? `0 0 0 4px ${FB_SOFT}, 0 14px 32px rgba(21,101,192,0.2), 0 3px 10px rgba(21,101,192,0.1)`
                        : SHADOW_XS,
                    background: isSelected
                        ? `linear-gradient(160deg, ${FB_SOFT} 0%, ${SURFACE} 65%)`
                        : SURFACE,
                    transition: `all 0.25s ${EASE}`,
                    transform: isSelected ? 'translateY(-3px)' : 'none',
                    "&:hover": { borderColor: FB, boxShadow: SHADOW_MD, transform: 'translateY(-3px)' },
                }}
            >
                {/* Top accent bar — only when selected */}
                <Box sx={{ height: 3, background: isSelected ? GRAD_BRAND : 'transparent', transition: `background 0.25s ${EASE}` }} />

                <Box sx={{ px: 1.9, pb: 1.9, pt: 1.5, display: "flex", alignItems: "center", gap: 1.35 }}>

                    {/* Icon box */}
                    <Box sx={{
                        width: 39, height: 39, borderRadius: '11px', flexShrink: 0,
                        background: isSelected ? GRAD_BRAND : '#eef2f8',
                        display: "flex", alignItems: "center", justifyContent: "center",
                        boxShadow: isSelected ? '0 5px 13px rgba(21,101,192,0.3)' : 'none',
                        transition: `all 0.25s ${EASE}`,
                    }}>
                        <BarChart sx={{ fontSize: 18, color: isSelected ? "#fff" : T2 }} />
                    </Box>

                    {/* Name + ID — takes remaining space */}
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography sx={{ fontSize: 13, fontWeight: 700, color: isSelected ? FB_DARK : T1, lineHeight: 1.3, letterSpacing: '-0.1px' }} noWrap>
                            {seriesName}
                        </Typography>
                    </Box>

                    {/* Right column: selected indicator + format badge (stacked) */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.65, flexShrink: 0 }}>
                        {/* Selected check — always reserve space to prevent layout shift */}
                        <Box sx={{
                            width: 18, height: 18, borderRadius: '50%',
                            background: isSelected ? GRAD_BRAND : 'transparent',
                            border: isSelected ? 'none' : `1.5px solid ${BORDER}`,
                            display: "flex", alignItems: "center", justifyContent: "center",
                            transition: `all 0.2s ${EASE}`,
                            boxShadow: isSelected ? '0 2px 5px rgba(21,101,192,0.3)' : 'none',
                        }}>
                            {isSelected && <CheckCircle sx={{ color: "#fff", fontSize: 12 }} />}
                        </Box>

                        {/* Format badge — plain Box, no Chip */}
                        {appliedFormat ? (
                            <Box sx={{
                                display: 'flex', alignItems: 'baseline', gap: '2px',
                                px: '7px', py: '2px',
                                bgcolor: GREEN_LT, borderRadius: '7px', border: `1px solid ${GREEN_BORDER}`,
                            }}>
                                <Typography component="span" sx={{ fontSize: 8.5, fontWeight: 700, color: GREEN, letterSpacing: '0.4px' }}>FMT</Typography>
                                <Typography component="span" sx={{ fontSize: 11, fontWeight: 700, color: GREEN, letterSpacing: '-0.2px', lineHeight: 1 }}>
                                    {String(appliedFormat).padStart(2, '0')}
                                </Typography>
                            </Box>
                        ) : (
                            <Box sx={{ px: '7px', py: '2px', bgcolor: SURFACE_ALT, borderRadius: '7px', border: `1px solid ${BORDER}` }}>
                                <Typography sx={{ fontSize: 10, color: T3, letterSpacing: '0.2px', lineHeight: 1.3 }}>—</Typography>
                            </Box>
                        )}
                    </Box>

                </Box>
            </Card>
        </Zoom>
    );
}

// ─── FORMAT CARD ──────────────────────────────────────────────────────────────
// ✅ Accepts pageSize (logic) and badgePageSize (display-only) props
function FormatCard({ format, pageSize, badgePageSize, selectedType, isApplied, onClick, cardIndex }) {
    const [imgLoaded, setImgLoaded] = useState(false);
    const { thumb } = getImageForTypeFormat(selectedType, format, pageSize);

    // ✅ This card is a real page-size variant if pageSize is not null (A4 or A5 selectable)
    const isPageSizeVariant = pageSize !== null && pageSize !== undefined;

    const showBadge = badgePageSize !== null && badgePageSize !== undefined;

    // Consolidated single-corner label: "FMT-01 · A4" instead of 3 scattered badges
    const cornerLabel = showBadge ? `FMT-${String(format).padStart(2, '0')} · ${badgePageSize}` : `FMT-${String(format).padStart(2, '0')}`;

    return (
        <Zoom in style={{ transitionDelay: `${cardIndex * 30}ms` }}>
            <Card onClick={onClick}
                sx={{
                    cursor: "pointer", borderRadius: '18px', overflow: "hidden",
                    position: "relative", bgcolor: SURFACE,
                    border: isApplied ? `2px solid ${FB}` : `1px solid ${BORDER}`,
                    boxShadow: isApplied
                        ? `0 0 0 4px ${FB_SOFT}, 0 16px 36px rgba(21,101,192,0.22), 0 4px 12px rgba(21,101,192,0.12)`
                        : SHADOW_XS,
                    transition: `all 0.28s ${EASE}`,
                    transform: isApplied ? 'translateY(-2px)' : 'none',
                    "&:hover": {
                        borderColor: FB,
                        boxShadow: isApplied
                            ? `0 0 0 4px ${FB_SOFT}, 0 20px 42px rgba(21,101,192,0.26), 0 4px 12px rgba(21,101,192,0.14)`
                            : SHADOW_LG,
                        transform: 'translateY(-4px)',
                    },
                }}
            >
                {/* Corner fold ribbon — replaces the old thin top bar + separate checkmark badge */}
                {isApplied && (
                    <Box sx={{
                        position: "absolute", top: 0, right: 0, width: 0, height: 0, zIndex: 2,
                        borderStyle: 'solid', borderWidth: '0 36px 36px 0', borderColor: `transparent ${FB} transparent transparent`,
                        filter: 'drop-shadow(-1px 1px 3px rgba(21,101,192,0.35))',
                    }}>
                        <CheckCircle sx={{ position: 'absolute', top: -31, right: -33, fontSize: 13, color: '#fff' }} />
                    </Box>
                )}

                <Box sx={{ position: "relative", bgcolor: SURFACE_ALT, aspectRatio: '3 / 4', height: { xs: 155, sm: 185, md: 205 }, overflow: "hidden" }}>
                    {!imgLoaded && (
                        <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" sx={{ bgcolor: '#e9edf5' }} />
                    )}
                    <CardMedia component="img" image={thumb} alt={`Format ${format}${isPageSizeVariant ? ` ${pageSize}` : ''}`}
                        onLoad={() => setImgLoaded(true)}
                        onError={(e) => { e.currentTarget.src = dummyImg; setImgLoaded(true); }}
                        sx={{ height: "100%", objectFit: "cover", display: imgLoaded ? "block" : "none", transition: `transform 0.4s ${EASE}`, "&:hover": { transform: "scale(1.05)" } }}
                    />
                    <Box sx={{ position: "absolute", inset: 0, background: "linear-gradient(to top, rgba(16,24,40,0.42) 0%, rgba(16,24,40,0.05) 32%, transparent 55%)", pointerEvents: "none" }} />

                    {/* ✅ Consolidated single label — bottom-left over the image, one clean pill instead of 3 badges */}
                    <Box sx={{
                        position: "absolute", bottom: 8, left: 8, px: '9px', py: '3px',
                        background: isApplied ? GRAD_BRAND : "rgba(16,24,40,0.55)", backdropFilter: 'blur(6px)',
                        borderRadius: '7px', boxShadow: isApplied ? '0 2px 8px rgba(21,101,192,0.4)' : '0 1px 3px rgba(0,0,0,0.2)',
                    }}>
                        <Typography sx={{ fontSize: 9.5, fontWeight: 700, color: "#fff", letterSpacing: '0.2px' }}>
                            {cornerLabel}
                        </Typography>
                    </Box>
                </Box>

                <CardContent sx={{ py: 1.15, px: 1.5, display: "flex", alignItems: "center", justifyContent: "space-between", borderTop: `1px solid ${BORDER_SOFT}`, bgcolor: isApplied ? FB_SOFT : SURFACE, "&:last-child": { pb: 1.15 } }}>
                    <Box sx={{ display: 'flex', alignItems: 'baseline', gap: '2px' }}>
                        <Typography component="span" sx={{ fontSize: 9.5, fontWeight: 600, color: T2, letterSpacing: '0.4px' }}>FMT</Typography>
                        <Typography component="span" sx={{ fontSize: 13.5, fontWeight: 700, color: T1, letterSpacing: '-0.2px' }}>{String(format).padStart(2, '0')}</Typography>
                    </Box>
                    {isApplied ? (
                        <Chip label="Active" size="small"
                            sx={{ fontSize: 9.5, fontWeight: 700, height: 20, bgcolor: GREEN_LT, color: GREEN, border: `1px solid ${GREEN_BORDER}`, borderRadius: '6px', letterSpacing: '0.2px', '& .MuiChip-label': { px: '7px' } }} />
                    ) : (
                        <Chip label="Preview" size="small"
                            sx={{ fontSize: 9.5, height: 20, bgcolor: BG, color: T2, border: `1px solid ${BORDER}`, borderRadius: '6px', '& .MuiChip-label': { px: '7px' } }} />
                    )}
                </CardContent>
            </Card>
        </Zoom>
    );
}

// ─── PREVIEW DIALOG ───────────────────────────────────────────────────────────
// ✅ pageSize is passed in as fixed value from the clicked card — NOT changeable in dialog
function PreviewDialog({ open, onClose, selectedType, selectedFormat, onApply, appliedFormat, selectedSeries, appliedPageSize, pageSize }) {
    const scaleRef = useRef(1);
    const originRef = useRef({ x: 50, y: 50 });
    const translateRef = useRef({ x: 0, y: 0 });
    const isDraggingRef = useRef(false);
    const dragStartRef = useRef({ mouseX: 0, mouseY: 0, translateX: 0, translateY: 0 });

    // ── React state only for triggering re-renders ──
    const [scale, setScale] = useState(1);
    const [origin, setOrigin] = useState({ x: 50, y: 50 });
    const [translate, setTranslate] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);

    const containerRef = useRef(null);

    const { large } = getImageForTypeFormat(selectedType, selectedFormat, pageSize);
    const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'));
    const isMultiSeries = MULTI_SERIES_TYPES.includes(selectedType);
    const seriesName = selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || selectedSeries?.name || '';

    // ✅ Show page size info bar for ALL PAGE_SIZE_DOCUMENT_TYPES (formats 1-10 display A4, 11-13 real A4/A5)
    const showPageSizeInfo = PAGE_SIZE_DOCUMENT_TYPES.includes(selectedType) && selectedFormat != null;

    // ✅ isAlreadyApplied checks format AND pageSize match
    // For formats 1-10 (pageSize=null from card click), just check format match
    const isAlreadyApplied = appliedFormat === selectedFormat &&
        (!shouldShowPageSize(selectedType, selectedFormat) || appliedPageSize === pageSize);

    // ── Master reset ──────────────────────────────────────────────────────────
    const resetAll = useCallback(() => {
        scaleRef.current = 1;
        originRef.current = { x: 50, y: 50 };
        translateRef.current = { x: 0, y: 0 };
        isDraggingRef.current = false;
        setScale(1);
        setOrigin({ x: 50, y: 50 });
        setTranslate({ x: 0, y: 0 });
        setIsDragging(false);
    }, []);

    // ── Reset when dialog closes ──────────────────────────────────────────────
    useEffect(() => {
        if (!open) resetAll();
    }, [open, resetAll]);

    // ── Get pointer position as % inside the container ────────────────────────
    const getPointerOrigin = useCallback((clientX, clientY) => {
        const container = containerRef.current;
        if (!container) return { x: 50, y: 50 };
        const rect = container.getBoundingClientRect();
        const x = Math.min(Math.max(((clientX - rect.left) / rect.width) * 100, 0), 100);
        const y = Math.min(Math.max(((clientY - rect.top) / rect.height) * 100, 0), 100);
        return { x, y };
    }, []);

    // ── Core zoom function — reads/writes refs, then syncs state ──────────────
    const applyZoom = useCallback((delta, pointerOrigin) => {
        const newScale = Math.min(Math.max(scaleRef.current * delta, 0.4), 5);
        scaleRef.current = newScale;

        if (pointerOrigin) {
            originRef.current = pointerOrigin;
            setOrigin({ ...pointerOrigin });
        }

        // Auto-reset translation when fully zoomed out
        if (newScale <= 1) {
            translateRef.current = { x: 0, y: 0 };
            setTranslate({ x: 0, y: 0 });
        }

        setScale(newScale);
    }, []);

    // ── Wheel handler ─────────────────────────────────────────────────────────
    const handleWheel = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        const po = getPointerOrigin(e.clientX, e.clientY);
        const delta = e.deltaY > 0 ? 0.93 : 1.07;
        applyZoom(delta, po);
    }, [getPointerOrigin, applyZoom]);

    // ── Attach wheel listener with { passive: false } ─────────────────────────
    useEffect(() => {
        const el = containerRef.current;
        if (!el || !open) return;
        el.addEventListener('wheel', handleWheel, { passive: false });
        return () => { el.removeEventListener('wheel', handleWheel); };
    }, [open, handleWheel]);

    // ── Button zoom ───────────────────────────────────────────────────────────
    const handleZoomIn = useCallback(() => { applyZoom(1.25, originRef.current); }, [applyZoom]);
    const handleZoomOut = useCallback(() => { applyZoom(0.8, originRef.current); }, [applyZoom]);
    const handleReset = useCallback(() => { resetAll(); }, [resetAll]);

    // ── Mouse move ────────────────────────────────────────────────────────────
    const handleMouseMove = useCallback((e) => {
        if (!isDraggingRef.current) {
            originRef.current = getPointerOrigin(e.clientX, e.clientY);
            return;
        }
        const dx = e.clientX - dragStartRef.current.mouseX;
        const dy = e.clientY - dragStartRef.current.mouseY;
        const newTranslate = {
            x: dragStartRef.current.translateX + dx,
            y: dragStartRef.current.translateY + dy,
        };
        translateRef.current = newTranslate;
        setTranslate({ ...newTranslate });
    }, [getPointerOrigin]);

    // ── Mouse down ────────────────────────────────────────────────────────────
    const handleMouseDown = useCallback((e) => {
        if (scaleRef.current <= 1) return;
        e.preventDefault();
        isDraggingRef.current = true;
        setIsDragging(true);
        dragStartRef.current = {
            mouseX: e.clientX,
            mouseY: e.clientY,
            translateX: translateRef.current.x,
            translateY: translateRef.current.y,
        };
    }, []);

    // ── Mouse up ──────────────────────────────────────────────────────────────
    const handleMouseUp = useCallback(() => {
        if (!isDraggingRef.current) return;
        isDraggingRef.current = false;
        setIsDragging(false);
    }, []);

    // ── Mouse leave ───────────────────────────────────────────────────────────
    const handleMouseLeave = useCallback(() => {
        if (!isDraggingRef.current) return;
        isDraggingRef.current = false;
        setIsDragging(false);
    }, []);

    // ── Touch handlers ────────────────────────────────────────────────────────
    const handleTouchStart = useCallback((e) => {
        if (scaleRef.current <= 1 || e.touches.length !== 1) return;
        const touch = e.touches[0];
        isDraggingRef.current = true;
        setIsDragging(true);
        dragStartRef.current = {
            mouseX: touch.clientX,
            mouseY: touch.clientY,
            translateX: translateRef.current.x,
            translateY: translateRef.current.y,
        };
    }, []);

    const handleTouchMove = useCallback((e) => {
        if (!isDraggingRef.current || e.touches.length !== 1) return;
        e.preventDefault();
        const touch = e.touches[0];
        const dx = touch.clientX - dragStartRef.current.mouseX;
        const dy = touch.clientY - dragStartRef.current.mouseY;
        const newTranslate = {
            x: dragStartRef.current.translateX + dx,
            y: dragStartRef.current.translateY + dy,
        };
        translateRef.current = newTranslate;
        setTranslate({ ...newTranslate });
    }, []);

    const handleTouchEnd = useCallback(() => {
        isDraggingRef.current = false;
        setIsDragging(false);
    }, []);

    // ── Attach touchmove with { passive: false } ──────────────────────────────
    useEffect(() => {
        const el = containerRef.current;
        if (!el || !open) return;
        el.addEventListener('touchmove', handleTouchMove, { passive: false });
        return () => { el.removeEventListener('touchmove', handleTouchMove); };
    }, [open, handleTouchMove]);

    // ✅ Resolve the display page size for the info bar:
    // - For formats 11–13 of Sale Challan/Purchase Dispatch: show whichever was clicked ('A4' or 'A5')
    // - For formats 1–10 of ALL PAGE_SIZE_DOCUMENT_TYPES: always show 'A4' (display only)
    const displayPageSize = shouldShowPageSize(selectedType, selectedFormat)
        ? (pageSize || 'A4')   // 11–13: use passed pageSize
        : 'A4';                 // 1–10 of ALL PAGE_SIZE_DOCUMENT_TYPES: always A4

    // ─────────────────────────────────────────────────────────────────────────
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth fullScreen={isMobile} TransitionComponent={Fade}
            PaperProps={{
                sx: { borderRadius: isMobile ? 0 : '20px', overflow: "hidden", maxHeight: isMobile ? "100vh" : "92vh", border: `1px solid rgba(16,24,40,0.06)`, boxShadow: SHADOW_LG }
            }}
        >
            {/* ── Header — rich gradient navy bar ── */}
            <Box sx={{
                display: "flex", alignItems: "center", justifyContent: "space-between", px: { xs: 2, sm: 3 }, py: 1.8,
                background: 'linear-gradient(135deg, #17233b 0%, #0c1526 100%)', position: 'relative', overflow: 'hidden',
            }}>
                <Box sx={{ position: 'absolute', inset: 0, background: GRAD_SHEEN, pointerEvents: 'none' }} />
                <Box sx={{ position: 'relative' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.4 }}>
                        <Typography sx={{ fontSize: 15, fontWeight: 700, color: "#fff", letterSpacing: '-0.2px' }}>
                            {selectedType}
                        </Typography>
                        {isMultiSeries && seriesName && (
                            <Box sx={{ px: '8px', py: '2px', bgcolor: 'rgba(255,255,255,0.14)', borderRadius: '7px' }}>
                                <Typography component="span" sx={{ fontSize: 11, color: "rgba(255,255,255,0.8)", fontWeight: 600 }}>
                                    {seriesName}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.55)", letterSpacing: '0.3px' }}>
                            FMT-{String(selectedFormat || '').padStart(2, '0')}
                        </Typography>
                        {/* ✅ Show page size badge in header for ALL PAGE_SIZE_DOCUMENT_TYPES formats */}
                        {showPageSizeInfo && (
                            <Box sx={{ px: "8px", py: "1px", bgcolor: displayPageSize === 'A4' ? 'rgba(21,101,192,0.55)' : 'rgba(18,128,92,0.55)', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.18)' }}>
                                <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#fff", letterSpacing: '0.5px' }}>
                                    {displayPageSize}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, position: 'relative' }}>
                    <Tooltip title="Zoom out">
                        <IconButton size="small" sx={{ color: "rgba(255,255,255,0.75)", transition: `all 0.2s ${EASE}`, '&:hover': { color: '#fff', bgcolor: 'rgba(255,255,255,0.12)', transform: 'scale(1.08)' } }} onClick={handleZoomOut}>
                            <ZoomOut sx={{ fontSize: 17 }} />
                        </IconButton>
                    </Tooltip>
                    <Box sx={{ px: "9px", py: "4px", bgcolor: "rgba(255,255,255,0.1)", borderRadius: '8px', mx: 0.5, border: '1px solid rgba(255,255,255,0.15)', textAlign: 'center', minWidth: 46 }}>
                        <Typography sx={{ fontSize: 8, fontWeight: 600, color: "rgba(255,255,255,0.45)", letterSpacing: '0.6px', lineHeight: 1, display: 'block', mb: '2px' }}>ZOOM</Typography>
                        <Typography sx={{ fontSize: 12, fontWeight: 700, color: "#fff", letterSpacing: '0.2px', lineHeight: 1, display: 'block' }}>
                            {Math.round(scale * 100)}%
                        </Typography>
                    </Box>
                    <Tooltip title="Zoom in">
                        <IconButton size="small" sx={{ color: "rgba(255,255,255,0.75)", transition: `all 0.2s ${EASE}`, '&:hover': { color: '#fff', bgcolor: 'rgba(255,255,255,0.12)', transform: 'scale(1.08)' } }} onClick={handleZoomIn}>
                            <ZoomIn sx={{ fontSize: 17 }} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Reset zoom">
                        <IconButton size="small" sx={{ color: "rgba(255,255,255,0.75)", transition: `all 0.2s ${EASE}`, '&:hover': { color: '#fff', bgcolor: 'rgba(255,255,255,0.12)', transform: 'scale(1.08)' } }} onClick={handleReset}>
                            <OpenInFull sx={{ fontSize: 15 }} />
                        </IconButton>
                    </Tooltip>
                    <Box sx={{ width: 1, height: 20, bgcolor: 'rgba(255,255,255,0.15)', mx: 0.5 }} />
                    <IconButton size="small" sx={{ color: "rgba(255,255,255,0.75)", transition: `all 0.2s ${EASE}`, '&:hover': { color: '#fff', bgcolor: 'rgba(255,255,255,0.14)', transform: 'rotate(90deg)' } }} onClick={onClose}>
                        <Close sx={{ fontSize: 17 }} />
                    </IconButton>
                </Box>
            </Box>

            {/* ✅ Static page size info bar — shown for ALL PAGE_SIZE_DOCUMENT_TYPES formats
                   No toggle — read only. Formats 1–10 always show A4, 11–13 show clicked variant */}
            {showPageSizeInfo && (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, px: { xs: 2, sm: 3 }, py: 1.1, bgcolor: SURFACE_ALT, borderBottom: `1px solid ${BORDER_SOFT}` }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0 }}>
                        <Box sx={{ width: 6, height: 6, borderRadius: '50%', background: GRAD_BRAND }} />
                        <Typography sx={{ fontSize: 11, fontWeight: 700, color: T2, whiteSpace: "nowrap", letterSpacing: '0.4px' }}>
                            PAGE SIZE
                        </Typography>
                    </Box>
                    {/* ✅ Static colored pill — NOT a button */}
                    <Box sx={{ px: "11px", py: "3px", background: displayPageSize === 'A4' ? GRAD_BRAND : `linear-gradient(135deg, ${GREEN} 0%, #0d5f45 100%)`, borderRadius: '7px', boxShadow: SHADOW_XS }}>
                        <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#fff", letterSpacing: "0.5px" }}>
                            {displayPageSize}
                        </Typography>
                    </Box>
                    <Typography sx={{ fontSize: 11.5, color: T2 }}>
                        {displayPageSize === 'A4' ? '210 × 297 mm · Standard A4' : '148 × 210 mm · Compact A5'}
                    </Typography>
                </Box>
            )}

            {/* ── Image / drag area ── */}
            <DialogContent
                ref={containerRef}
                sx={{
                    p: 0, display: "flex", alignItems: "center", justifyContent: "center",
                    minHeight: isMobile ? "calc(100vh - 140px)" : 400, overflow: "hidden",
                    cursor: isDragging ? "grabbing" : scale > 1 ? "grab" : "zoom-in", position: "relative", userSelect: "none",
                    background: 'radial-gradient(circle at 50% 30%, #eef1f7 0%, #e2e6ee 100%)',
                    backgroundImage: 'radial-gradient(circle at 50% 30%, #eef1f7 0%, #e2e6ee 100%), linear-gradient(rgba(16,24,40,0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(16,24,40,0.035) 1px, transparent 1px)',
                    backgroundSize: 'cover, 24px 24px, 24px 24px',
                }}
                onMouseMove={handleMouseMove}
                onMouseDown={handleMouseDown}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseLeave}
                onTouchStart={handleTouchStart}
                onTouchEnd={handleTouchEnd}
            >
                <Box sx={{ transition: isDragging ? "none" : `transform 0.2s ${EASE}`, transform: `translate(${translate.x}px, ${translate.y}px) scale(${scale})`, transformOrigin: `${origin.x}% ${origin.y}%`, display: "inline-block", lineHeight: 0, pointerEvents: "none" }}>
                    <img src={large} alt="Preview" draggable={false} onError={(e) => { e.currentTarget.src = dummyImg; }}
                        style={{ maxWidth: "100%", maxHeight: isMobile ? "70vh" : "60vh", objectFit: "contain", display: "block", userSelect: "none", pointerEvents: "none", boxShadow: '0 12px 40px rgba(16,24,40,0.28)', borderRadius: 4 }}
                    />
                </Box>
            </DialogContent>

            {/* ── Footer ── */}
            <Box sx={{ px: { xs: 2, sm: 3 }, py: 1.75, display: "flex", gap: 1.5, justifyContent: showPageSizeInfo ? "space-between" : "flex-end", alignItems: "center", borderTop: `1px solid ${BORDER_SOFT}`, bgcolor: SURFACE, flexWrap: "wrap" }}>
                {/* ✅ Left: static page size info text — read only */}
                {showPageSizeInfo && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <Box sx={{ width: 3, height: 18, borderRadius: '4px', background: GRAD_BRAND, flexShrink: 0 }} />
                        <Typography sx={{ fontSize: 12.5, color: T2 }}>
                            Will print on{" "}
                            <Box component="span" sx={{ fontWeight: 700, color: T1 }}>
                                {displayPageSize}
                            </Box>
                            {" "}
                            <Box component="span" sx={{ color: T3 }}>
                                ({displayPageSize === 'A4' ? '210 × 297 mm' : '148 × 210 mm'})
                            </Box>
                        </Typography>
                    </Box>
                )}

                {/* Right: action buttons */}
                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                    <Button onClick={onClose} sx={btnGhostSx}>Cancel</Button>
                    <Button
                        onClick={onApply}
                        disabled={isAlreadyApplied}
                        startIcon={isAlreadyApplied
                            ? <CheckCircle sx={{ fontSize: 15 }} />
                            : <AutoAwesome sx={{ fontSize: 15 }} />}
                        sx={{
                            ...btnPrimarySx,
                            ...(isAlreadyApplied && {
                                background: GREEN_LT, color: GREEN,
                                border: `1px solid ${GREEN_BORDER}`, boxShadow: 'none',
                                "&:disabled": { background: GREEN_LT, color: GREEN, boxShadow: 'none' }
                            }),
                        }}
                    >
                        {isAlreadyApplied ? "Currently Active" : "Apply Template"}
                    </Button>
                </Box>
            </Box>
        </Dialog>
    );
}

// ─── MAIN ─────────────────────────────────────────────────────────────────────
export default function FormatSelectionScreen({ loggedInUser, companyData, connectionString }) {
    const API = connectionString;
    const auth = useAuth();
    const { selectedCompany } = useAuth();
    const authSelectedCompany = auth?.selectedCompany ?? null;
    const muiTheme = useTheme();
    const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(muiTheme.breakpoints.down('md'));

    const [selectedType, setSelectedType] = useState('');
    const [selectedFormat, setSelectedFormat] = useState(null);
    // ✅ Track selected page size from card click
    const [selectedCardPageSize, setSelectedCardPageSize] = useState(null);
    const [appliedFormat, setAppliedFormat] = useState(null);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [snack, setSnack] = useState({ open: false, msg: '', severity: 'success' });

    // ✅ State to track current format count
    const [currentFormatCount, setCurrentFormatCount] = useState(FORMAT_COUNT);

    // ✅ Page size state — stored per unique key (type + series + format + pageSize)
    const [pageSizeMap, setPageSizeMap] = useState({});
    const [appliedPageSize, setAppliedPageSize] = useState(null);

    // ✅ Track applied format+pageSize combos separately for variant cards
    const [appliedVariantMap, setAppliedVariantMap] = useState({});

    // Multi-series states
    const [seriesList, setSeriesList] = useState([]);
    const [selectedSeries, setSelectedSeries] = useState(null);
    const [seriesFormats, setSeriesFormats] = useState({});
    const [seriesPageSizes, setSeriesPageSizes] = useState({});
    const [loadingSeries, setLoadingSeries] = useState(false);

    // Signature checkbox state
    const [signatureChecked, setSignatureChecked] = useState(false);
    // QR Code checkbox state (Sale Invoice only)
    const [qrCodeChecked, setQrCodeChecked] = useState(false);
    // Color picker state
    const [selectedColor, setSelectedColor] = useState('#FF0000');
    const [colorAnchor, setColorAnchor] = useState(null);

    const AppRegID = selectedCompany?.AppRegID || null;
    const isMultiSeriesType = MULTI_SERIES_TYPES.includes(selectedType);

    // ── Company resolution ────────────────────────────────────────────────────
    const companyFromProp = Array.isArray(companyData) ? companyData[0] : (companyData || null);
    let fallbackLS = null;
    try {
        const s = typeof window !== 'undefined' ? window.localStorage.getItem('selectedCompany') : null;
        if (s) fallbackLS = JSON.parse(s);
    } catch { fallbackLS = null; }

    const companyObj = authSelectedCompany || companyFromProp
        || (loggedInUser && (loggedInUser.selectedCompany || loggedInUser.company || loggedInUser.companyData))
        || fallbackLS || {};

    // ── Plan-based document-type visibility ─────────────────────────────────
    // "Billing" plan  -> Quotation, Sale Challan, Sale Invoice, Credit Note only.
    // "Accounting" plan (or any other/unknown plan) -> every document type, unchanged.
    const planName = selectedCompany?.planName || companyObj?.planName;
    const visibleDocumentTypes = planName === 'Billing'
        ? documentTypes.filter(t => BILLING_PLAN_DOC_TYPES.includes(t))
        : documentTypes;

    const tryNum = (v) => { if (v == null || v === '') return 0; const n = Number(v); return isFinite(n) ? n : 0; };
    const GCompId_RAW = companyObj?.GCompId ?? companyObj?.GCompid ?? companyObj?.GCompID ?? null;
    const GCompId = (GCompId_RAW == null || GCompId_RAW === '') ? null : tryNum(GCompId_RAW);

    let CompId = 0;
    for (const c of [companyObj?.CompId, companyObj?.CompID, companyObj?.Compid, companyObj?.CompanyId, loggedInUser?.CompId, loggedInUser?.CompanyId]) {
        const n = tryNum(c);
        if (n > 0) { CompId = n; break; }
    }
    if (!CompId && fallbackLS) {
        for (const c of [fallbackLS?.CompId, fallbackLS?.CompID, fallbackLS?.CompanyId]) {
            const n = tryNum(c);
            if (n > 0) { CompId = n; break; }
        }
    }

    const CURRENT_USER_ID = Number(loggedInUser?.UserId ?? loggedInUser?.UserID ?? 0);
    const toMySqlDT = (d) => {
        const p = (n) => String(n).padStart(2, '0');
        return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
    };

    const getBookNameKey = (type, series = null) => {
        const base = type.replace(/\s+/g, '');
        if (series) {
            const seriesId = series?.SeriesId || series?.SeriesID || series?.seriesId || series?.Id || series?.id || 0;
            return `${base}_Series_${seriesId}`;
        }
        return base;
    };

    const getSeriesId = (series) => {
        return series?.SeriesId || series?.SeriesID || series?.seriesId || series?.Id || series?.id || 0;
    };

    // ✅ Build a unique key for appliedVariantMap
    const buildVariantKey = useCallback((format, pageSize, type, series = null) => {
        const typeKey = (type || '').replace(/\s+/g, '');
        const seriesKey = series ? `_s${getSeriesId(series)}` : '';
        const psKey = pageSize ? `_${pageSize}` : '';
        return `${typeKey}${seriesKey}_f${format}${psKey}`;
    }, []);

    // ✅ Build a unique key for pageSizeMap: type + optional series + format
    const buildPageSizeKey = useCallback((format, type, series = null) => {
        const typeKey = (type || '').replace(/\s+/g, '');
        const seriesKey = series ? `_s${getSeriesId(series)}` : '';
        return `${typeKey}${seriesKey}_f${format}`;
    }, []);

    // ✅ Get current page size — only meaningful for Sale Challan + format 11/12/13
    const currentPageSize = useCallback((format, type, series) => {
        if (!shouldShowPageSize(type, format)) return 'A4'; // default, not used
        const key = buildPageSizeKey(format, type, isMultiSeriesType ? series : null);
        return pageSizeMap[key] || 'A4'; // default A4
    }, [pageSizeMap, buildPageSizeKey, isMultiSeriesType]);

    // ── Sync signatureChecked from fresh companies API (not cached context) ──────────────
    useEffect(() => {
        if (!selectedType || !CompId) {
            setSignatureChecked(false);
            return;
        }

        const fetchSignatureStatus = async () => {
            try {
                // ✅ Fetch fresh format data with cache-buster
                const cacheBreaker = new Date().getTime();
                const resp = await axios.get(`${API}/api/companies`, {
                    params: { companyId: CompId, t: cacheBreaker },
                    timeout: 15000,
                });

                let comps = [];
                if (resp?.data) {
                    if (Array.isArray(resp.data.companies)) comps = resp.data.companies;
                    else if (Array.isArray(resp.data)) comps = resp.data;
                    else if (Array.isArray(resp.data.data)) comps = resp.data.data;
                }

                const norm = (s) => String(s || '').replace(/\s+/g, '').toLowerCase();
                const wantedBookName = norm(selectedType);
                const wantedId = Number(CompId || 0);

                let matchedFormat = null;
                for (const c of comps) {
                    if (Number(c?.CompId ?? c?.CompID ?? 0) === wantedId && Array.isArray(c.formats)) {
                        for (const f of c.formats) {
                            const fBookName = norm(f.BookName || f.bookName || '');
                            const fSeriesId = Number(f.SeriesId || f.seriesId || 0);

                            if (isMultiSeriesType && selectedSeries) {
                                const sId = getSeriesId(selectedSeries);
                                if (fBookName === wantedBookName && fSeriesId === Number(sId)) {
                                    matchedFormat = f;
                                    break;
                                }
                            } else {
                                if (fBookName === wantedBookName) {
                                    matchedFormat = f;
                                    break;
                                }
                            }
                        }
                        if (matchedFormat) break;
                    }
                }

                // ✅ Use matched format's Signature (fresh from API)
                setSignatureChecked(matchedFormat ? !!matchedFormat.Signature : false);
            } catch (err) {
                console.warn('Error fetching signature status from API:', err?.message);
                setSignatureChecked(false);
            }
        };

        fetchSignatureStatus();
    }, [selectedType, selectedSeries, appliedFormat, CompId]);

    // ── Sync qrCodeChecked from fresh companies API (Sale Invoice only, not cached context) ────
    useEffect(() => {
        if (!selectedType || !CompId) {
            setQrCodeChecked(false);
            return;
        }

        // Only show QR code checkbox for Sale Invoice
        const norm = (s) => String(s || '').replace(/\s+/g, '').toLowerCase();
        if (norm(selectedType) !== 'saleinvoice') {
            setQrCodeChecked(false);
            return;
        }

        const fetchQRCodeStatus = async () => {
            try {
                // ✅ Fetch fresh format data with cache-buster
                const cacheBreaker = new Date().getTime();
                const resp = await axios.get(`${API}/api/companies`, {
                    params: { companyId: CompId, t: cacheBreaker },
                    timeout: 15000,
                });

                let comps = [];
                if (resp?.data) {
                    if (Array.isArray(resp.data.companies)) comps = resp.data.companies;
                    else if (Array.isArray(resp.data)) comps = resp.data;
                    else if (Array.isArray(resp.data.data)) comps = resp.data.data;
                }

                const wantedBookName = norm(selectedType);
                const wantedId = Number(CompId || 0);

                let matchedFormat = null;
                for (const c of comps) {
                    if (Number(c?.CompId ?? c?.CompID ?? 0) === wantedId && Array.isArray(c.formats)) {
                        for (const f of c.formats) {
                            const fBookName = norm(f.BookName || f.bookName || '');
                            const fSeriesId = Number(f.SeriesId || f.seriesId || 0);

                            if (isMultiSeriesType && selectedSeries) {
                                const sId = getSeriesId(selectedSeries);
                                if (fBookName === wantedBookName && fSeriesId === Number(sId)) {
                                    matchedFormat = f;
                                    break;
                                }
                            } else {
                                if (fBookName === wantedBookName) {
                                    matchedFormat = f;
                                    break;
                                }
                            }
                        }
                        if (matchedFormat) break;
                    }
                }

                // ✅ Use matched format's QRCode (fresh from API)
                setQrCodeChecked(matchedFormat ? !!matchedFormat.QRCode : false);
            } catch (err) {
                console.warn('Error fetching QRCode status from API:', err?.message);
                setQrCodeChecked(false);
            }
        };

        fetchQRCodeStatus();
    }, [selectedType, selectedSeries, appliedFormat, CompId]);

    // ── Sync selectedColor from fresh companies API ────
    useEffect(() => {
        if (!selectedType || !CompId) {
            setSelectedColor('#000000');
            setUserSelectedColor(null);
            return;
        }

        const fetchColorStatus = async () => {
            try {
                const cacheBreaker = new Date().getTime();
                const resp = await axios.get(`${API}/api/companies`, {
                    params: { companyId: CompId, t: cacheBreaker },
                    timeout: 15000,
                });

                let comps = [];
                if (resp?.data) {
                    if (Array.isArray(resp.data.companies)) comps = resp.data.companies;
                    else if (Array.isArray(resp.data)) comps = resp.data;
                    else if (Array.isArray(resp.data.data)) comps = resp.data.data;
                }

                const norm = (s) => String(s || '').replace(/\s+/g, '').toLowerCase();
                const wantedBookName = norm(selectedType);
                const wantedId = Number(CompId || 0);

                let matchedFormat = null;
                for (const c of comps) {
                    if (Number(c?.CompId ?? c?.CompID ?? 0) === wantedId && Array.isArray(c.formats)) {
                        for (const f of c.formats) {
                            const fBookName = norm(f.BookName || f.bookName || '');
                            const fSeriesId = Number(f.SeriesId || f.seriesId || 0);

                            if (isMultiSeriesType && selectedSeries) {
                                const sId = getSeriesId(selectedSeries);
                                if (fBookName === wantedBookName && fSeriesId === Number(sId)) {
                                    matchedFormat = f;
                                    break;
                                }
                            } else {
                                if (fBookName === wantedBookName) {
                                    matchedFormat = f;
                                    break;
                                }
                            }
                        }
                        if (matchedFormat) break;
                    }
                }

                // ✅ If user hasn't selected a color for this format yet, use saved color or default to black
                // If user previously selected a color (userSelectedColor is set), use that instead
                const colorFromDB = matchedFormat?.Color || '#000000';
                const colorToUse = userSelectedColor || colorFromDB;
                setSelectedColor(colorToUse);
            } catch (err) {
                console.warn('Error fetching color status from API:', err?.message);
                setSelectedColor(userSelectedColor || '#000000');
            }
        };

        fetchColorStatus();
    }, [selectedType, selectedSeries, appliedFormat, CompId]);

    const handleSignatureChange = async (e) => {
        const checked = e.target.checked;
        setSignatureChecked(checked);
        try {
            const bookName = selectedType.replace(/\s+/g, '');
            const seriesId = isMultiSeriesType && selectedSeries ? getSeriesId(selectedSeries) : null;
            await axios.put(`${API}/api/printmaster/signature`, {
                CompId,
                BookName: bookName,
                SeriesId: seriesId,
                Signature: checked ? 1 : 0,
                EditUserId: CURRENT_USER_ID,
            }, { headers: { 'Content-Type': 'application/json' }, timeout: 15000 });

            // ✅ Success - no need to reload, local state is already updated
            console.log('[Signature] Updated successfully');
        } catch (err) {
            console.error('[Signature Update Error]', {
                status: err.response?.status,
                data: err.response?.data,
                message: err.message
            });
            setSignatureChecked(!checked);
            setSnack({ open: true, msg: 'Failed to update signature setting.', severity: 'error' });
        }
    };

    // ── Handle QR Code toggle (Sale Invoice only) ──────────────────────────────
    const handleQRCodeChange = async (e) => {
        const checked = e.target.checked;
        setQrCodeChecked(checked);
        try {
            const bookName = selectedType.replace(/\s+/g, '');
            const seriesId = isMultiSeriesType && selectedSeries ? getSeriesId(selectedSeries) : null;
            await axios.put(`${API}/api/printmaster/qrcode`, {
                CompId,
                BookName: bookName,
                SeriesId: seriesId,
                QRCode: checked ? 1 : 0,
                EditUserId: CURRENT_USER_ID,
            }, { headers: { 'Content-Type': 'application/json' }, timeout: 15000 });

            // ✅ Success - no need to reload, local state is already updated
            console.log('[QR Code] Updated successfully');
        } catch (err) {
            console.error('[QR Code Update Error]', {
                status: err.response?.status,
                data: err.response?.data,
                message: err.message
            });
            setQrCodeChecked(!checked);
            setSnack({ open: true, msg: 'Failed to update QR code setting.', severity: 'error' });
        }
    };

    // ── Handle Color change ──────────────────────────────────────────────────────
    const handleColorChange = async (color) => {
        setSelectedColor(color);
        // ✅ Track user's explicit color selection
        setUserSelectedColor(color);
        setColorAnchor(null);
        try {
            const bookName = selectedType.replace(/\s+/g, '');
            const seriesId = isMultiSeriesType && selectedSeries ? getSeriesId(selectedSeries) : null;
            await axios.put(`${API}/api/printmaster/color`, {
                CompId,
                BookName: bookName,
                SeriesId: seriesId,
                Color: color,
                EditUserId: CURRENT_USER_ID,
            }, { headers: { 'Content-Type': 'application/json' }, timeout: 15000 });

            console.log('[Color] Updated successfully to', color);
            setSnack({ open: true, msg: `Color updated to ${color}`, severity: 'success' });
        } catch (err) {
            console.error('[Color Update Error]', {
                status: err.response?.status,
                data: err.response?.data,
                message: err.message
            });
            setSnack({ open: true, msg: 'Failed to update color setting.', severity: 'error' });
            // Revert on error
            setSelectedColor(selectedColor);
            setUserSelectedColor(null);
        }
    };

    // ✅ Predefined colors list (BLACK as default)
    const COLORS = [
        // Deep/Dark Colors - Maximum Contrast
        { name: 'Black', hex: '#000000', rgb: '(0,0,0)' },
        { name: 'White', hex: '#FFFFFF', rgb: '(255,255,255)' },
        { name: 'Light Gray', hex: '#959e9e', rgb: '(149,158,158)' },
        { name: 'Dark Gray', hex: '#4e5454', rgb: '(78,84,84)' },
        { name: 'Navy Blue', hex: '#0D1B3C', rgb: '(13,27,60)' },
        { name: 'Deep Indigo', hex: '#1A0A33', rgb: '(26,10,51)' },

        // Bold Primary Blues - Strong Contrast
        { name: 'Royal Blue', hex: '#1565C0', rgb: '(21,101,192)' },
        { name: 'Bright Cyan', hex: '#00BCD4', rgb: '(0,188,212)' },

        // Green Family - Distinct shades
        { name: 'Teal', hex: '#009688', rgb: '(0,150,136)' },
        { name: 'Forest Green', hex: '#1B5E20', rgb: '(27,94,32)' },
        { name: 'Lime Green', hex: '#76FF03', rgb: '(118,255,3)' },

        // Purple & Pink
        { name: 'Purple', hex: '#7B1FA2', rgb: '(123,31,162)' },
        { name: 'Deep Pink', hex: '#C2185B', rgb: '(194,24,91)' },

        // Red & Orange
        { name: 'Red', hex: '#D32F2F', rgb: '(211,47,47)' },
        { name: 'Deep Orange', hex: '#E64A19', rgb: '(230,74,25)' },
        { name: 'Amber', hex: '#FFC107', rgb: '(255,193,7)' },

        // Dark/Bold Colors - High Contrast Alternative
        { name: 'Dark Cyan', hex: '#006064', rgb: '(0,96,100)' },
        { name: 'Dark Green', hex: '#004D40', rgb: '(0,77,64)' },
        { name: 'Dark Olive', hex: '#33691E', rgb: '(51,105,30)' },
        { name: 'Dark Yellow', hex: '#F57F17', rgb: '(245,127,23)' },
        { name: 'Maroon', hex: '#800000', rgb: '(128,0,0)' },
        { name: 'Dark Blue', hex: '#01579B', rgb: '(1,87,155)' },
        { name: 'Dark Purple', hex: '#4A148C', rgb: '(74,20,140)' },
        { name: 'Dark Red', hex: '#B71C1C', rgb: '(183,28,28)' },
    ];

    // ✅ Track if user has explicitly selected a color for current format
    const [userSelectedColor, setUserSelectedColor] = useState(null);

    // ── Fetch series ──────────────────────────────────────────────────────────
    const fetchSeriesForType = async (type) => {
        setLoadingSeries(true);
        setSeriesList([]);
        setSelectedSeries(null);
        setSeriesFormats({});
        setSeriesPageSizes({});
        try {
            const companyIdParam = CompId || 0;
            const typeNorm = type.replace(/\s+/g, '');
            const resp = await axios.get(`${API}/api/seriesForPDF`, {
                params: { companyId: companyIdParam, documentType: typeNorm },
                timeout: 15000,
            });

            let arr = [];
            if (resp?.data) {
                if (Array.isArray(resp.data.series)) arr = resp.data.series;
                else if (Array.isArray(resp.data)) arr = resp.data;
                else if (Array.isArray(resp.data.data)) arr = resp.data.data;
            }
            setSeriesList(arr);

            if (arr.length > 0) {
                try {
                    // ✅ Add cache-buster to get fresh data
                    const cacheBreaker = new Date().getTime();
                    const fmtResp = await axios.get(`${API}/api/companies`, {
                        params: { companyId: companyIdParam, t: cacheBreaker },
                        timeout: 15000,
                    });
                    let companies = [];
                    if (fmtResp?.data) {
                        if (Array.isArray(fmtResp.data.companies)) companies = fmtResp.data.companies;
                        else if (Array.isArray(fmtResp.data)) companies = fmtResp.data;
                        else if (Array.isArray(fmtResp.data.data)) companies = fmtResp.data.data;
                    }
                    const wantedId = Number(CompId || companyIdParam || 0);
                    const rec = companies.find(c => tryNum(c?.CompId ?? c?.CompID ?? 0) === wantedId) || companies[0];
                    if (rec && Array.isArray(rec.formats)) {
                        const norm = (s) => String(s || '').replace(/\s+/g, '').toLowerCase();
                        const fmtMap = {};
                        const pageSizeMap = {};
                        for (const series of arr) {
                            const sId = getSeriesId(series);
                            const wantedBookName = norm(typeNorm);
                            for (const f of rec.formats) {
                                const bName = norm(f?.BookName ?? '');
                                const bId = Number(f?.BookID ?? f?.BookId ?? 0);
                                const fSeriesId = Number(f?.SeriesId ?? f?.seriesId ?? 0);
                                if (bId && bName === wantedBookName && fSeriesId === Number(sId)) {
                                    fmtMap[sId] = bId;
                                    pageSizeMap[sId] = f?.PageSize || null;
                                    break;
                                }
                            }
                            if (!fmtMap[sId]) {
                                for (const f of rec.formats) {
                                    const bName = norm(f?.BookName ?? '');
                                    const bId = Number(f?.BookID ?? f?.BookId ?? 0);
                                    const fSeriesId = Number(f?.SeriesId ?? f?.seriesId ?? 0);
                                    if (bId && bName === wantedBookName && (!fSeriesId || fSeriesId === 0)) {
                                        fmtMap[sId] = bId;
                                        pageSizeMap[sId] = f?.PageSize || null;
                                        break;
                                    }
                                }
                            }
                        }
                        setSeriesFormats(fmtMap);
                        setSeriesPageSizes(pageSizeMap);
                    }
                } catch (err) {
                    console.warn('Error fetching series formats', err?.message);
                }
            }
        } catch (err) {
            console.warn('Series API error', err?.response?.data || err?.message);
            setSeriesList([]);
            setSelectedSeries(null);
            setSeriesFormats({});
            setSeriesPageSizes({});
            setSnack({ open: true, msg: err?.response?.data?.message || 'Failed to load series.', severity: 'error' });
        } finally {
            setLoadingSeries(false);
        }
    };

    // ── Handlers ─────────────────────────────────────────────────────────────
    const handleSelectType = async (type) => {
        // ✅ Update format count based on selected type
        const formatCount = getFormatCount(type);
        setCurrentFormatCount(formatCount);

        setSelectedType(type);
        setSelectedFormat(null);
        setSelectedCardPageSize(null);
        setAppliedFormat(null);
        setAppliedPageSize(null);
        setSelectedSeries(null);
        setSeriesList([]);
        setSeriesFormats({});
        setSeriesPageSizes({});
        setAppliedVariantMap({});
        // ✅ Reset user color selection when changing document type
        setUserSelectedColor(null);
        setSelectedColor('#000000');

        if (MULTI_SERIES_TYPES.includes(type)) {
            await fetchSeriesForType(type);
        } else {
            try {
                const companyIdParam = CompId || 0;
                // ✅ Add cache-buster to get fresh data
                const cacheBreaker = new Date().getTime();
                const resp = await axios.get(`${API}/api/companies`, { params: { companyId: companyIdParam, t: cacheBreaker }, timeout: 15000 });
                let arr = [];
                if (resp?.data) {
                    if (Array.isArray(resp.data.companies)) arr = resp.data.companies;
                    else if (Array.isArray(resp.data)) arr = resp.data;
                    else if (Array.isArray(resp.data.data)) arr = resp.data.data;
                }
                const wantedId = Number(CompId || companyIdParam || 0);
                const rec = arr.find(c => tryNum(c?.CompId ?? c?.CompID ?? 0) === wantedId) || arr[0];
                if (rec && Array.isArray(rec.formats)) {
                    const norm = (s) => String(s || '').replace(/\s+/g, '').toLowerCase();
                    const wantedNorm = norm(type);
                    let found = null;
                    let foundPageSize = null;
                    for (const f of rec.formats) {
                        const bName = norm(f?.BookName ?? '');
                        const bId = Number(f?.BookID ?? f?.BookId ?? 0);
                        if (bId && bName === wantedNorm) {
                            found = bId;
                            foundPageSize = f?.PageSize || null;
                            break;
                        }
                    }
                    setAppliedFormat(found ?? 1);
                    setAppliedPageSize(foundPageSize);
                } else {
                    setAppliedFormat(1);
                    setAppliedPageSize(null);
                }
            } catch (err) {
                console.warn('companies API error', err?.message);
            }
        }
    };

    const handleSelectSeries = (series) => {
        setSelectedSeries(series);
        setSelectedFormat(null);
        setSelectedCardPageSize(null);
        const sId = getSeriesId(series);
        const fmt = seriesFormats[sId] || null;
        const pageSize = seriesPageSizes[sId] || null;
        setAppliedFormat(fmt);
        setAppliedPageSize(pageSize);
        // ✅ Reset user color selection when changing series (will fetch from API in useEffect)
        setUserSelectedColor(null);
    };

    // ✅ handleCardClick receives both format and pageSize from the card
    const handleCardClick = (format, pageSize) => {
        setSelectedFormat(format);
        setSelectedCardPageSize(pageSize); // null for non-variant, 'A4'/'A5' for variant cards
        setPreviewOpen(true);
    };

    // ✅ Helper: check if a specific format+pageSize variant card is applied
    const isVariantApplied = useCallback((format, pageSize, type, series) => {
        if (!shouldShowPageSize(type, format)) {
            // Non-variant (formats 1–10, including ALL PAGE_SIZE_DOCUMENT_TYPES display-only A4):
            // just check appliedFormat — pageSize logic unchanged
            return appliedFormat === format;
        }
        // Variant card (formats 11–13): check both appliedFormat AND appliedPageSize
        return appliedFormat === format && appliedPageSize === pageSize;
    }, [appliedFormat, appliedPageSize]);

    const handleApplyTemplate = async () => {
        if (!selectedType || !selectedFormat) {
            setSnack({ open: true, msg: 'Select a document type and format first.', severity: 'warning' });
            return;
        }
        if (isMultiSeriesType && !selectedSeries) {
            setSnack({ open: true, msg: 'Please select a series first.', severity: 'warning' });
            return;
        }
        if (!CompId) {
            setSnack({ open: true, msg: 'Unable to determine your company. Please select a company first.', severity: 'error' });
            return;
        }

        const now = new Date();
        const bookName = selectedType.replace(/\s+/g, '');
        const seriesId = isMultiSeriesType ? getSeriesId(selectedSeries) : null;

        // ✅ Determine PageSize to send — only for Sale Challan/Purchase Dispatch + format 11/12/13
        const isPageSizeApplicable = shouldShowPageSize(selectedType, selectedFormat);
        // ✅ Use selectedCardPageSize (set when card was clicked) as the effective page size — fixed, not changeable
        const effectivePageSize = isPageSizeApplicable
            ? (selectedCardPageSize || 'A4')
            : null;

        // ✅ Use selectedColor (which is #000000 by default if not changed), or preserve user's previous selection
        const colorToStore = selectedColor || '#000000';

        const payload = {
            GCompId: null, CompId,
            BookName: bookName,
            BookID: Number(selectedFormat),
            FormName: isMultiSeriesType
                ? `${selectedType}-Series-${seriesId}-Format-${selectedFormat}`
                : `${selectedType}-Format-${selectedFormat}`,
            CompDefault: 0, PPO: 0,
            paperheight: 842, paperwidth: 595,
            TopMargin: 0, LeftMargin: 0, RightMargin: 0, BottomMargin: 0,
            Heading: '',
            AddUserId: CURRENT_USER_ID, AddUserDateTime: toMySqlDT(now),
            EditUserId: CURRENT_USER_ID, EditUserDateTime: toMySqlDT(now),
            AppRegID,
            ...(isMultiSeriesType && seriesId ? { SeriesId: seriesId } : {}),
            // ✅ Include PageSize only for Sale Challan/Purchase Dispatch + format 11/12/13
            ...(isPageSizeApplicable && effectivePageSize ? { PageSize: effectivePageSize } : {}),
            // ✅ Always include color in payload (default black #000000 if not selected)
            Color: colorToStore,
        };

        try {
            const res = await axios.post(`${API}/api/printmaster`, payload, { headers: { 'Content-Type': 'application/json' }, timeout: 15000 });
            const ok = res?.data?.success === true || res?.data?.insertId || (res?.data?.affectedRows > 0);
            if (ok) {
                const newFormat = Number(selectedFormat);
                setAppliedFormat(newFormat);

                if (isPageSizeApplicable && effectivePageSize) {
                    setAppliedPageSize(effectivePageSize);
                    // ✅ Mark this specific variant as applied
                    const variantKey = buildVariantKey(newFormat, effectivePageSize, selectedType, isMultiSeriesType ? selectedSeries : null);
                    setAppliedVariantMap(prev => ({ ...prev, [variantKey]: true }));
                } else {
                    setAppliedPageSize(null);
                }

                if (isMultiSeriesType && selectedSeries) {
                    const sId = getSeriesId(selectedSeries);
                    setSeriesFormats(prev => ({ ...prev, [sId]: newFormat }));
                }
                setPreviewOpen(false);
                setSelectedFormat(null);
                setSelectedCardPageSize(null);
                const seriesLabel = isMultiSeriesType && selectedSeries
                    ? ` for ${selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || 'series'}`
                    : '';
                // ✅ Include page size in success message when applicable
                const pageSizeLabel = isPageSizeApplicable && effectivePageSize
                    ? ` (${effectivePageSize})`
                    : '';
                setSnack({
                    open: true,
                    msg: `Format ${selectedFormat}${pageSizeLabel} applied successfully${seriesLabel}!`,
                    severity: 'success',
                });
            } else {
                setSnack({ open: true, msg: res?.data?.message || 'Failed to apply template.', severity: 'error' });
            }
        } catch (err) {
            const msg = err.response?.data?.message || `Server error ${err.response?.status || ''}` || 'Network error.';
            setSnack({ open: true, msg, severity: 'error' });
        }
    };

    const showFormatGrid = selectedType && (!isMultiSeriesType || (isMultiSeriesType && selectedSeries));

    const getActiveFormatLabel = () => {
        if (isMultiSeriesType && selectedSeries) {
            const sId = getSeriesId(selectedSeries);
            const fmt = seriesFormats[sId];
            if (fmt) {
                const sName = selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || `Series ${sId}`;
                return `Format ${fmt} — ${sName}`;
            }
            return null;
        }
        if (appliedFormat && selectedType && !isMultiSeriesType) {
            // ✅ Include page size in label if applicable
            if (appliedPageSize && shouldShowPageSize(selectedType, appliedFormat)) {
                return `Format ${appliedFormat} (${appliedPageSize}) active`;
            }
            return `Format ${appliedFormat} active`;
        }
        return null;
    };

    const activeLabel = getActiveFormatLabel();

    // ✅ Build the expanded format list for the current type
    const formatList = buildFormatList(selectedType, currentFormatCount);

    // ─── RENDER ───────────────────────────────────────────────────────────────
    return (
        <Box sx={{ minHeight: "100vh", background: `linear-gradient(180deg, ${BG} 0%, #eef1f8 100%)` }}>

            {/* ── MODULE HEADER — kept visually light/receding so it doesn't compete with the primary task area below ── */}
            <Box sx={{ bgcolor: SURFACE, borderBottom: `1px solid ${BORDER_SOFT}`, px: { xs: 2, sm: 3, md: 4 }, boxShadow: 'none' }}>
                {/* Main header row */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.75, flexWrap: 'wrap', gap: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Box sx={{ width: 44, height: 44, background: GRAD_BRAND, borderRadius: '13px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, boxShadow: SHADOW_BRAND, position: 'relative', overflow: 'hidden' }}>
                            <Box sx={{ position: 'absolute', inset: 0, background: GRAD_SHEEN }} />
                            <FilePresent sx={{ fontSize: 23, color: '#fff', position: 'relative' }} />
                        </Box>
                        <Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.25 }}>
                                <Typography sx={{ fontSize: 18, fontWeight: 800, color: T1, letterSpacing: '-0.4px' }}>
                                    Printing Utilities
                                </Typography>
                                <Chip label="PRT-UTL" size="small"
                                    sx={{ height: 20, fontSize: 10, fontWeight: 700, letterSpacing: '0.5px', bgcolor: FB_LIGHT, color: FB, border: `1px solid ${FB_MID}`, borderRadius: '6px' }} />
                            </Box>
                            <Typography sx={{ fontSize: 12.5, color: T2 }}>
                                Document template configuration
                                {companyObj?.CompanyName ? ` · ${companyObj.CompanyName}` : ''}
                            </Typography>
                        </Box>
                    </Box>
                    {activeLabel && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', px: 1.6, py: 0.8, bgcolor: GREEN_LT, border: `1px solid ${GREEN_BORDER}`, borderRadius: '10px', boxShadow: SHADOW_XS }}>
                            <CheckCircle sx={{ fontSize: 14, color: GREEN }} />
                            <Typography sx={{ fontSize: 12, fontWeight: 700, color: GREEN }}>
                                {activeLabel}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Box>

            {/* ── CONTENT ── */}
            <Box sx={{ maxWidth: 1280, mx: "auto", px: { xs: 1.5, sm: 3, md: 4 }, py: { xs: 2, sm: 3 } }}>

              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: { xs: 2, sm: 2.5, md: 3 }, alignItems: 'flex-start' }}>

                {/* ── SIDEBAR — Document Type Navigator ── */}
                <Box
                    component="nav"
                    aria-label="Document types"
                    sx={{
                        ...cardBaseSx,
                        // Secondary/receding surface — lighter border, minimal shadow so it doesn't compete with the primary task area
                        border: `1px solid ${BORDER_SOFT}`,
                        boxShadow: SHADOW_XS,
                        width: { xs: '100%', md: 268 },
                        flexShrink: 0,
                        position: { md: 'sticky' },
                        top: { md: 16 },
                        alignSelf: { md: 'flex-start' },
                        overflow: 'hidden',
                    }}
                >
                    {/* Sidebar header — brand gradient cap, distinct from panel headers */}
                    <Box sx={{
                        display: 'flex', alignItems: 'center', gap: 1.1, px: 2.25, py: 1.7,
                        background: 'linear-gradient(135deg, #17233b 0%, #0c1526 100%)', position: 'relative', overflow: 'hidden',
                    }}>
                        <Box sx={{ position: 'absolute', inset: 0, background: GRAD_SHEEN, pointerEvents: 'none' }} />
                        <Box sx={{ width: 22, height: 22, borderRadius: '7px', background: GRAD_BRAND, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, position: 'relative' }}>
                            <FilePresent sx={{ fontSize: 13, color: '#fff' }} />
                        </Box>
                        <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: '#fff', letterSpacing: '0.6px', textTransform: 'uppercase', position: 'relative' }}>
                            Document Types
                        </Typography>
                    </Box>

                    {/* Nav rows — horizontal scroll strip on mobile/tablet, vertical stack on desktop */}
                    <Box sx={{
                        display: 'flex',
                        flexDirection: { xs: 'row', md: 'column' },
                        overflowX: { xs: 'auto', md: 'visible' },
                        gap: { xs: 1, md: 0 },
                        p: { xs: 1.25, md: 1 },
                        '&::-webkit-scrollbar': { height: 5 },
                        '&::-webkit-scrollbar-thumb': { background: BORDER, borderRadius: 3 },
                    }}>
                        {visibleDocumentTypes.map((type) => {
                            const isActive = selectedType === type;
                            const isMulti = MULTI_SERIES_TYPES.includes(type);
                            // ✅ Shows an indicator dot when this type currently has an applied format
                            const hasApplied = isActive && !!appliedFormat;
                            const DocIcon = getDocTypeIcon(type);
                            return (
                                <Box
                                    key={type}
                                    onClick={() => handleSelectType(type)}
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleSelectType(type); } }}
                                    sx={{
                                        position: 'relative',
                                        display: 'flex', alignItems: 'center', gap: 1.1,
                                        px: 1.6, py: 1.25,
                                        mb: { xs: 0, md: 0.4 },
                                        flexShrink: 0,
                                        minWidth: { xs: 168, md: 'auto' },
                                        cursor: 'pointer',
                                        borderRadius: '12px',
                                        border: isActive ? `1.5px solid ${FB}` : '1.5px solid transparent',
                                        background: isActive ? FB_SOFT : 'transparent',
                                        boxShadow: isActive ? SHADOW_XS : 'none',
                                        transition: `all 0.2s ${EASE}`,
                                        '&:hover': { background: isActive ? FB_SOFT : SURFACE_ALT, borderColor: isActive ? FB : BORDER },
                                    }}
                                >
                                    {/* Active rail — left accent bar, desktop only (Stripe-style nav rail) */}
                                    <Box sx={{
                                        display: { xs: 'none', md: 'block' },
                                        position: 'absolute', left: -9, top: '18%', bottom: '18%', width: 3,
                                        borderRadius: '0 4px 4px 0',
                                        background: isActive ? GRAD_BRAND : 'transparent',
                                        transition: `background 0.2s ${EASE}`,
                                    }} />

                                    {/* Icon chip */}
                                    <Box sx={{
                                        width: 32, height: 32, borderRadius: '9px', flexShrink: 0,
                                        background: isActive ? GRAD_BRAND : '#eef2f8',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        boxShadow: isActive ? '0 3px 10px rgba(21,101,192,0.3)' : 'none',
                                        transition: `all 0.2s ${EASE}`,
                                    }}>
                                        <DocIcon sx={{ fontSize: 16, color: isActive ? '#fff' : T2 }} />
                                    </Box>

                                    {/* Label + multi-series sublabel */}
                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                        <Typography sx={{ fontSize: 13.5, fontWeight: isActive ? 700 : 600, color: isActive ? FB_DARK : T1, letterSpacing: isActive ? '-0.1px' : 0, lineHeight: 1.3 }} noWrap>
                                            {type}
                                        </Typography>
                                        {isMulti && (
                                            <Typography sx={{ fontSize: 10, color: isActive ? FB : T3, fontWeight: 600, letterSpacing: '0.2px' }}>
                                                Multi-series
                                            </Typography>
                                        )}
                                    </Box>

                                    {/* Applied indicator dot + chevron */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6, flexShrink: 0 }}>
                                        {hasApplied && (
                                            <Box sx={{ width: 7, height: 7, borderRadius: '50%', background: GREEN, boxShadow: '0 0 0 3px rgba(18,128,92,0.14)' }} />
                                        )}
                                        <ArrowForwardIos sx={{
                                            fontSize: 9, color: isActive ? FB : '#cbd5e1',
                                            display: { xs: 'none', md: 'block' },
                                            transition: `all 0.2s ${EASE}`,
                                        }} />
                                    </Box>
                                </Box>
                            );
                        })}
                    </Box>
                </Box>

                {/* ── MAIN CONTENT — Series selector + format grid for the active type ── */}
                <Box sx={{ flex: 1, minWidth: 0, width: '100%' }}>

                {/* ── STEP 2 — Series Selector (conditional) ── */}
                {isMultiSeriesType && selectedType && (
                    <Fade in={isMultiSeriesType}>
                        {/* Secondary panel — lighter border/shadow so the format grid below reads as the primary focus */}
                        <Box sx={{ ...cardBaseSx, border: `1px solid ${BORDER_SOFT}`, boxShadow: SHADOW_XS, mb: { xs: 2, sm: 2.5 } }}>

                            {/* Panel header strip — plain section title + icon (no numbered wizard-step badge) */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, px: 2.25, py: 1.25, bgcolor: SURFACE_ALT, borderBottom: `1px solid ${BORDER_SOFT}` }}>
                                <Box sx={{ width: 22, height: 22, borderRadius: '7px', background: GRAD_BRAND, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, boxShadow: '0 2px 6px rgba(21,101,192,0.3)' }}>
                                    <BarChart sx={{ fontSize: 12, color: '#fff' }} />
                                </Box>
                                <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: T1, letterSpacing: '0.4px', textTransform: 'uppercase' }}>
                                    Series Selection
                                </Typography>
                                {/* Plain Box badge — avoids Chip sizing issues */}
                                <Box sx={{ px: '9px', py: '3px', bgcolor: FB_SOFT, border: `1px solid ${FB_MID}`, borderRadius: '7px' }}>
                                    <Typography sx={{ fontSize: 9.5, fontWeight: 700, color: FB, letterSpacing: '0.2px' }}>Multi-series</Typography>
                                </Box>
                                {selectedSeries && (
                                    <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: '5px', px: '11px', py: '4px', bgcolor: GREEN_LT, border: `1px solid ${GREEN_BORDER}`, borderRadius: '8px' }}>
                                        <CheckCircle sx={{ fontSize: 10.5, color: GREEN }} />
                                        <Typography sx={{ fontSize: 10.5, fontWeight: 700, color: GREEN }}>
                                            {selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || 'Selected'}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>

                            {/* Panel body */}
                            <Box sx={{ px: 2, py: 1.75 }}>

                                {loadingSeries ? (
                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", py: 4, gap: 1.2 }}>
                                        <CircularProgress size={18} thickness={4} sx={{ color: FB }} />
                                        <Typography sx={{ fontSize: 11.5, color: T2, fontWeight: 500 }}>Loading series…</Typography>
                                    </Box>

                                ) : seriesList.length > 0 ? (
                                    <>
                                        <Typography sx={{ fontSize: 11, color: T2, mb: 1.5, lineHeight: 1.55 }}>
                                            Each series can be assigned an independent print template. Select a series to configure it.
                                        </Typography>

                                        <Grid container spacing={1}>
                                            {seriesList.map((series, index) => {
                                                const sId = getSeriesId(series);
                                                const isSelected = selectedSeries && getSeriesId(selectedSeries) === sId;
                                                const sAppliedFormat = seriesFormats[sId] || null;
                                                return (
                                                    <Grid item key={sId} xs={12} sm={6} md={3}>
                                                        <SeriesCard
                                                            series={series}
                                                            isSelected={isSelected}
                                                            appliedFormat={sAppliedFormat}
                                                            onClick={handleSelectSeries}
                                                            index={index}
                                                        />
                                                    </Grid>
                                                );
                                            })}
                                        </Grid>
                                    </>

                                ) : (
                                    <Box sx={{ py: 5, textAlign: "center", border: `1.5px dashed ${BORDER}`, borderRadius: '16px', bgcolor: SURFACE_ALT }}>
                                        <Box sx={{ width: 46, height: 46, background: FB_SOFT, borderRadius: '13px', display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 1.3, border: `1px solid ${FB_MID}` }}>
                                            <BarChart sx={{ fontSize: 22, color: FB }} />
                                        </Box>
                                        <Typography sx={{ fontSize: 13.5, fontWeight: 700, color: T1, mb: 0.5 }}>
                                            No series found
                                        </Typography>
                                        <Typography sx={{ fontSize: 12.5, color: T2 }}>
                                            No series available for {selectedType}. Create a series first.
                                        </Typography>
                                    </Box>
                                )}

                            </Box>
                        </Box>
                    </Fade>
                )}

                {/* ── STEP 2 or 3 — Format Template Grid ── */}
                {showFormatGrid ? (
                    <Fade in={showFormatGrid}>
                        {/* Primary task area — richer shadow + subtle brand-tinted wash so it visually leads the page */}
                        <Box sx={{
                            ...cardBaseSx,
                            border: `1px solid ${BORDER}`,
                            boxShadow: SHADOW_LG,
                            background: `linear-gradient(180deg, ${FB_LIGHT} 0%, ${SURFACE} 140px)`,
                        }}>
                            {/* Panel header strip */}
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, px: 2, py: 1, bgcolor: 'transparent', borderBottom: `1px solid ${BORDER_SOFT}`, flexWrap: 'wrap' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                    <Box sx={{ width: 19, height: 19, borderRadius: '6px', background: GRAD_BRAND, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, boxShadow: '0 2px 6px rgba(21,101,192,0.3)' }}>
                                        <FilePresent sx={{ fontSize: 10, color: '#fff' }} />
                                    </Box>
                                    <Typography sx={{ fontSize: 10.5, fontWeight: 700, color: T1, letterSpacing: '0.4px', textTransform: 'uppercase' }}>
                                        Template Format
                                    </Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6, px: '10px', py: '4px', bgcolor: SURFACE, border: `1px solid ${BORDER}`, borderRadius: '7px', boxShadow: SHADOW_XS }}>
                                        <Typography sx={{ fontSize: 9.5, fontWeight: 700, color: T1 }}>{selectedType}</Typography>
                                        {isMultiSeriesType && selectedSeries && (
                                            <>
                                                <Typography sx={{ fontSize: 9, color: '#cbd5e1', mx: 0.2 }}>|</Typography>
                                                <Typography sx={{ fontSize: 9.5, fontWeight: 700, color: FB }}>
                                                    {selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || 'Series'}
                                                </Typography>
                                            </>
                                        )}
                                        <Typography sx={{ fontSize: 9, color: '#cbd5e1', mx: 0.2 }}>|</Typography>
                                        <Typography sx={{ fontSize: 9.5, color: T2, fontWeight: 500 }}>{formatList.length} templates</Typography>
                                    </Box>
                                </Box>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, flexWrap: "wrap" }}>
                                    {appliedFormat && (
                                        <Box sx={{ display: "flex", alignItems: "center", gap: '5px', px: '9px', py: '4px', bgcolor: GREEN_LT, border: `1px solid ${GREEN_BORDER}`, borderRadius: '7px', boxShadow: SHADOW_XS }}>
                                            <CheckCircle sx={{ fontSize: 10.5, color: GREEN }} />
                                            <Typography sx={{ fontSize: 9.5, fontWeight: 700, color: GREEN, letterSpacing: '0.2px' }}>
                                                FMT-{String(appliedFormat).padStart(2, '0')}
                                                {appliedPageSize && shouldShowPageSize(selectedType, appliedFormat) && (
                                                    <Box component="span" sx={{ ml: 0.5, fontWeight: 600 }}>({appliedPageSize})</Box>
                                                )}
                                                {' '}ACTIVE
                                                {isMultiSeriesType && selectedSeries && (
                                                    <Box component="span" sx={{ ml: 0.5, fontWeight: 500, opacity: 0.8 }}>· this series</Box>
                                                )}
                                            </Typography>
                                        </Box>
                                    )}
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={signatureChecked}
                                                onChange={handleSignatureChange}
                                                disabled={!appliedFormat}
                                                size="small"
                                                sx={{ p: 0.4, color: FB_MID, '&.Mui-checked': { color: FB }, '&.Mui-disabled': { color: '#cbd5e1' }, borderRadius: '6px' }}
                                            />
                                        }
                                        label={
                                            <Typography sx={{ fontSize: 10.5, color: appliedFormat ? T1 : T3, fontWeight: 600 }}>
                                                {appliedFormat ? 'Show Authorized Signature' : 'Apply format to enable signature'}
                                            </Typography>
                                        }
                                        sx={{ mr: 0, gap: 0.3 }}
                                    />

                                    {/* ✅ QR Code checkbox (Sale Invoice only) */}
                                    {selectedType && String(selectedType || '').replace(/\s+/g, '').toLowerCase() === 'saleinvoice' && (
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={qrCodeChecked}
                                                    onChange={handleQRCodeChange}
                                                    disabled={!appliedFormat}
                                                    size="small"
                                                    sx={{ p: 0.4, color: FB_MID, '&.Mui-checked': { color: FB }, '&.Mui-disabled': { color: '#cbd5e1' }, borderRadius: '6px' }}
                                                />
                                            }
                                            label={
                                                <Typography sx={{ fontSize: 10.5, color: appliedFormat ? T1 : T3, fontWeight: 600 }}>
                                                    {appliedFormat ? 'Show QR Code' : 'Apply format to enable QR code'}
                                                </Typography>
                                            }
                                            sx={{ mr: 0, gap: 0.3 }}
                                        />
                                    )}

                                    {/* ✅ Color Picker Button */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Button
                                            onClick={(e) => setColorAnchor(e.currentTarget)}
                                            disabled={!appliedFormat}
                                            startIcon={<PaletteOutlined sx={{ fontSize: 13 }} />}
                                            sx={{
                                                px: 1.1,
                                                py: 0.4,
                                                height: 28,
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 0.4,
                                                bgcolor: appliedFormat ? SURFACE : SURFACE_ALT,
                                                border: `1px solid ${BORDER}`,
                                                borderRadius: '8px',
                                                color: appliedFormat ? T1 : T3,
                                                fontSize: 10.5,
                                                fontWeight: 600,
                                                textTransform: 'none',
                                                boxShadow: appliedFormat ? SHADOW_XS : 'none',
                                                cursor: appliedFormat ? 'pointer' : 'not-allowed',
                                                transition: `all 0.2s ${EASE}`,
                                                '&:hover': { bgcolor: appliedFormat ? SURFACE_ALT : SURFACE_ALT, boxShadow: appliedFormat ? SHADOW_SM : 'none' },
                                            }}
                                        >
                                            <Box sx={{ width: 13, height: 13, borderRadius: '4px', bgcolor: selectedColor, border: `1.5px solid rgba(0,0,0,0.15)`, flexShrink: 0, mr: 0.4 }} />
                                            <Typography sx={{ fontSize: 10.5, fontWeight: 600 }}>
                                                {appliedFormat ? 'Color: ' + selectedColor : 'Apply format to set color'}
                                            </Typography>
                                        </Button>

                                        <Popover
                                            open={Boolean(colorAnchor)}
                                            anchorEl={colorAnchor}
                                            onClose={() => setColorAnchor(null)}
                                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                            PaperProps={{
                                                sx: {
                                                    borderRadius: '18px',
                                                    boxShadow: SHADOW_LG,
                                                    border: `1px solid ${BORDER_SOFT}`,
                                                    mt: 1,
                                                }
                                            }}
                                        >
                                            <Box sx={{ p: 2.5, bgcolor: SURFACE, maxWidth: 480 }}>
                                                {/* Header */}
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                                                    <Box>
                                                        <Typography sx={{ fontSize: 14, fontWeight: 800, color: T1, letterSpacing: '-0.1px', display: 'flex', alignItems: 'center', gap: 0.75 }}>
                                                            <PaletteOutlined sx={{ fontSize: 17, color: FB }} /> Color Palette
                                                        </Typography>
                                                        <Typography sx={{ fontSize: 11.5, color: T2, mt: 0.35 }}>
                                                            Choose a color for your template
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                        <Box sx={{ width: 34, height: 34, borderRadius: '10px', bgcolor: selectedColor, border: `2px solid ${FB}`, boxShadow: SHADOW_SM }} />
                                                    </Box>
                                                </Box>

                                                {/* Color Grid */}
                                                <Grid container spacing={1.2}>
                                                    {COLORS.map((color, index) => (
                                                        <Grid item xs={4} sm={3} key={color.hex}>
                                                            <Box
                                                                onClick={() => handleColorChange(color.hex)}
                                                                sx={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'center',
                                                                    gap: 0.8,
                                                                    padding: 1.2,
                                                                    borderRadius: '14px',
                                                                    bgcolor: selectedColor === color.hex ? FB_SOFT : SURFACE_ALT,
                                                                    border: selectedColor === color.hex ? `2px solid ${FB}` : `1.5px solid ${BORDER}`,
                                                                    cursor: 'pointer',
                                                                    transition: `all 0.22s ${EASE}`,
                                                                    position: 'relative',
                                                                    '&:hover': {
                                                                        bgcolor: FB_SOFT,
                                                                        borderColor: FB,
                                                                        transform: 'translateY(-3px)',
                                                                        boxShadow: SHADOW_MD,
                                                                    },
                                                                }}
                                                            >
                                                                {/* Color Swatch */}
                                                                <Box sx={{ width: 48, height: 48, borderRadius: '10px', bgcolor: color.hex, border: `2px solid rgba(0,0,0,0.08)`, boxShadow: SHADOW_SM, transition: `transform 0.2s ${EASE}` }} />

                                                                {/* Checkmark for selected */}
                                                                {selectedColor === color.hex && (
                                                                    <Box sx={{ position: 'absolute', top: -8, right: -8, width: 26, height: 26, borderRadius: '50%', background: GRAD_BRAND, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 3px 10px rgba(21,101,192,0.45)' }}>
                                                                        <CheckCircle sx={{ fontSize: 15, color: '#fff' }} />
                                                                    </Box>
                                                                )}

                                                                {/* Color Name */}
                                                                <Typography sx={{ fontSize: 11, fontWeight: 700, color: T1, textAlign: 'center', lineHeight: 1.3, mt: 0.5 }}>
                                                                    {color.name}
                                                                </Typography>

                                                                {/* Hex Code */}
                                                                <Typography sx={{ fontSize: 9, color: T3, textAlign: 'center', fontFamily: 'monospace', letterSpacing: '0.5px' }}>
                                                                    {color.hex}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                    ))}
                                                </Grid>

                                                {/* Footer */}
                                                <Box sx={{ mt: 2.5, pt: 2, borderTop: `1px solid ${BORDER_SOFT}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <Typography sx={{ fontSize: 11, color: T2, fontWeight: 500 }}>
                                                        {COLORS.length} colors available
                                                    </Typography>
                                                    <Button
                                                        onClick={() => setColorAnchor(null)}
                                                        sx={{
                                                            px: 1.6,
                                                            py: 0.6,
                                                            height: 34,
                                                            fontSize: 12,
                                                            fontWeight: 700,
                                                            borderRadius: '9px',
                                                            textTransform: 'none',
                                                            bgcolor: BG,
                                                            color: T1,
                                                            border: `1px solid ${BORDER}`,
                                                            transition: `all 0.2s ${EASE}`,
                                                            '&:hover': { bgcolor: '#e7ebf3' },
                                                        }}
                                                    >
                                                        Done
                                                    </Button>
                                                </Box>
                                            </Box>
                                        </Popover>
                                    </Box>
                                </Box>
                            </Box>

                            {/* Format card grid */}
                            <Box sx={{ p: { xs: 1.5, sm: 2 } }}>
                                <Grid container spacing={{ xs: 1, sm: 1.25 }}>
                                    {formatList.map((item, cardIndex) => {
                                        // ✅ Determine if this specific card (format + pageSize combo) is applied
                                        const cardIsApplied = isVariantApplied(
                                            item.format,
                                            item.pageSize,
                                            selectedType,
                                            isMultiSeriesType ? selectedSeries : null
                                        );
                                        return (
                                            <Grid item key={`${item.format}_${item.pageSize || 'std'}`} xs={6} sm={4} md={2.4}>
                                                <FormatCard
                                                    format={item.format}
                                                    pageSize={item.pageSize}
                                                    badgePageSize={item.badgePageSize}
                                                    selectedType={selectedType}
                                                    isApplied={cardIsApplied}
                                                    onClick={() => handleCardClick(item.format, item.pageSize)}
                                                    cardIndex={cardIndex}
                                                />
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                            </Box>

                        </Box>
                    </Fade>
                ) : !selectedType ? (
                    <Box sx={{ ...cardBaseSx, py: { xs: 8, sm: 10 }, textAlign: "center" }}>
                        <Box sx={{ width: 58, height: 58, background: FB_SOFT, borderRadius: '18px', display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2.2, border: `1px solid ${FB_MID}`, boxShadow: SHADOW_XS }}>
                            <FilePresent sx={{ fontSize: 28, color: FB }} />
                        </Box>
                        <Typography sx={{ fontSize: 15, fontWeight: 800, color: T1, mb: 0.8, letterSpacing: '-0.2px' }}>
                            No Document Type Selected
                        </Typography>
                        <Typography sx={{ fontSize: 13, color: T2 }}>
                            Select a document type above to browse print templates
                        </Typography>
                    </Box>
                ) : isMultiSeriesType && !selectedSeries ? (
                    !loadingSeries && seriesList.length > 0 && (
                        <Box sx={{ ...cardBaseSx, py: { xs: 7, sm: 9 }, textAlign: "center" }}>
                            <Box sx={{ width: 58, height: 58, background: FB_SOFT, borderRadius: '18px', display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2.2, border: `1px solid ${FB_MID}`, boxShadow: SHADOW_XS }}>
                                <BarChart sx={{ fontSize: 28, color: FB }} />
                            </Box>
                            <Typography sx={{ fontSize: 15, fontWeight: 800, color: T1, mb: 0.8 }}>
                                Select a Series
                            </Typography>
                            <Typography sx={{ fontSize: 13, color: T2 }}>
                                Choose a series above to configure its template format
                            </Typography>
                        </Box>
                    )
                ) : null}

                </Box>
                {/* end MAIN CONTENT */}
              </Box>
              {/* end sidebar + content flex row */}
            </Box>

            {/* ── Preview dialog ── */}
            <PreviewDialog
                open={previewOpen}
                onClose={() => { setPreviewOpen(false); setSelectedFormat(null); setSelectedCardPageSize(null); }}
                selectedType={selectedType}
                selectedFormat={selectedFormat}
                appliedFormat={appliedFormat}
                onApply={handleApplyTemplate}
                selectedSeries={selectedSeries}
                // ✅ Pass selectedCardPageSize as fixed pageSize — no toggle inside dialog
                pageSize={selectedCardPageSize || 'A4'}
                appliedPageSize={appliedPageSize}
            />

            {/* ── Snackbar ── */}
            <Snackbar open={snack.open} autoHideDuration={3500} onClose={() => setSnack(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
                <Alert severity={snack.severity} variant="filled" onClose={() => setSnack(s => ({ ...s, open: false }))}
                    sx={{ borderRadius: '12px', fontWeight: 700, fontSize: 13, boxShadow: SHADOW_LG, alignItems: 'center' }}>
                    {snack.msg}
                </Alert>
            </Snackbar>
        </Box>
    );
}